const esLocale = {
  test: `Localización de prueba`,
  dashboard: `Panel`,
  engage: `Comprometer`,
  assets: `Activos`,
  submissions: `Envíos`,
  impact: `Impacto`,
  programmes: `Programas`,
  interactions: `Interacciones`,
  donations: `Donaciones`,
  impact_strategy: `Estrategia de impacto`,
  my_profile: `Mi perfil`,
  organisation: `Organización`,
  users: `Usuarios`,
  profile: `Perfil`,
  help: `Ayuda`,
  logout: `Cerrar sesión`,
  insights: `Perspectivas`,
  data: `Datos`,
  progress: `Progreso`,
  ideas: `Ideas`,
  reviewed: `Revisado`,
  in_progress: `En curso`,
  pending_review: `Revisión pendiente`,
  most_popular_theme: `Tema más popular`,
  local_resident: `Residente local`,
  local_business: `Negocios Locales`,
  charitable_group: `Grupo caritativo`,
  other_stakeholder: `Otras partes interesadas`,
  cultural: `Cultural`,
  environmental: `Ambiental`,
  economic: `Económico`,
  educational: `Educativo`,
  social: `Social`,
  responder_types: `Tipos de respondedores`,
  most_popular_category: `Categoría más popular`,
  green_spaces: `Espacios Verdes`,
  local_tourism: `Turismo Local`,
  skills_development: `Desarrollo de habilidades`,
  other: `Otro`,
  most_popular_sub_category: `Subcategoría más popular`,
  grassland: `Pradera`,
  burgers: `hamburguesas`,
  green_skills: `Habilidades verdes`,
  filters: `Filtros`,
  theme: `Tema`,
  category: `Categoría`,
  sub_category: `Subcategoría`,
  ideas_by_phase: `Ideas por fase`,
  oops: `¡Ups! El nombre de usuario/contraseña puede ser incorrecto`,
  forgot_password: `¿Has olvidado tu contraseña?`,
  forgot_password_line1: `Si tiene una cuenta, habrá recibido un correo electrónico de "Restablecer contraseña" del soporte de BizGive. Siga el enlace de ese correo electrónico para crear una nueva contraseña.`,
  forgot_password_line2: `Por favor revise también su carpeta de spam.`,
  forgot_password_line3: `Si no recibe un correo electrónico es posible que no tenga una cuenta activa. Comuníquese con el soporte de BizGive.`,
  forgot_password_header: `Por favor revisa tu bandeja de entrada`,
  incorrect_email_id: `Por favor verifique la identificación de correo electrónico que ingresó.`,
  forget_password: `Olvidar Contraseña`,
  forget_password_hint: `Utilice más de 8 caracteres, una letra mayúscula y minúscula, un número y un carácter especial.`,
  date_submitted: `Fecha de envío`,
  feedback_type: `Tipo de comentario`,
  need: `Necesidad`,
  attributes: `Atributos`,
  happy_to_be_contacted: `¿Feliz de ser contactado?`,
  contact_information: `Información del contacto`,
  the_sender_has_multiple_submissions: `El remitente tiene varios envíos.`,
  actions: `Comportamiento`,
  add_comment: `Agregar comentario`,
  date_actioned: `Fecha de acción`,
  actioned_by: `Actuado por`,
  back_to_map: `Volver al mapa`,
  submitter_type: `Tipo de remitente`,
  submitter_location: `Ubicación del remitente`,
  submission_location: `Ubicación de envío`,
  categories: `Categorías`,
  yes: `Sí`,
  no: `No`,
  save: `Ahorrar`,
  idea_location: `Ubicación de la idea`,
  please_populate: `Por favor complete`,
  comments_added_successfully: `Comentarios agregados exitosamente`,
  see_location: `Ver Ubicación`,
  feedback: `Comentario`,
  feedback_by_phase: `Comentarios por fase`,
  feedback_location: `Ubicación de comentarios`,
  comment: `Comentario`,
  asset: `Activo`,
  phase: `Fase`,
  idea: `Idea`,
  submitter: `Remitente`,
  requestedContact: `¿Contacto solicitado?`,
  collaborate: `Colaborar`,
  contact_by_phase: `Contacto por Fase`,
  collaborate_location: `Ubicación de colaboración`,
  number_of_employees: `No. Empleados`,
  global_annual_turnover: `Volumen de negocios anual global (millones de libras esterlinas)`,
  industry: `Industria`,
  services_provided: `Servicios prestados`,
  services_description: `Descripción de servicios`,
  renewable_experience: `¿Experiencia renovable?`,
  requested_introduction_to_tier_one_contractors: `¿Solicitó una introducción a los contratistas de nivel 1?`,
  organization_name: `Nombre de la organización`,
  website: `Sitio web`,
  overview: `Descripción general`,
  all_projects: `Todos los proyectos`,
  total_visitors: `Visitantes totales`,
  feedback_submitted: `Comentarios enviados`,
  ideas_submitted: `Ideas enviadas`,
  collaborations_submitted: `Colaboraciones enviadas`,
  pending_actions: `Acciones Pendientes`,
  three_month_historical_visitors: `Visitantes históricos de 3 meses`,
  submission_type: `Tipo de envío`,
  collaborations: `Colaboraciones`,
  applications: `Aplicaciones`,
  action_required: `Acción requerida`,
  pending_response: `Pendiente de respuesta`,
  pre_approved: `Preaprobado`,
  approved: `Aprobado`,
  declined: `Rechazado`,
  your_session_will_expire_in: `Su sesión caducará en…`,
  select_whether_you_would_like_to_stay_logged_in_or_log_out: `Seleccione si desea permanecer conectado o cerrar sesión. Si no hace nada, se cerrará su sesión automáticamente por razones de seguridad.`,
  stay_logged_in: `Manténgase conectado`,
  log_out: `Finalizar la sesión`,
  all_phases: `Todas las fases`,
  login: `Acceso`,
  not_registered_yet: `¿Aún no estás registrado?`,
  sign_up: `Inscribirse`,
  user_terms: `Términos de usuario`,
  privacy_policy: `política de privacidad`,
  create_an_account_to_apply_for_support: `Cree una cuenta para solicitar soporte`,
  are_you_impact_funder_contact_us: `¿Eres un financiador de impacto? Contáctenos`,
  confirm_password: `confirmar Contraseña`,
  password_must_include: `La contraseña debe incluir:`,
  more_than_eight_characters: `- Más de 8 caracteres`,
  an_upper_and_lower_case_character: `- Un carácter en mayúsculas y minúsculas.`,
  a_number: `- un número`,
  a_special_character: `- Un personaje especial`,
  i_accept_the: `Acepto el`,
  register: `Registro`,
  connect_with_funders_and_design_your_opportunities_to_create_positive_impact: `Conéctese con financiadores y diseñe sus oportunidades para crear un impacto positivo`,
  or_login_to_create_your_free_BizGive_account: `o inicie sesión para crear su cuenta BizGive gratuita.`,
  discover: `Descubrir`,
  funding_programmes_and_create_a_profile_to_receive_alerts: `programas de financiación y crear un perfil para recibir alertas.`,
  submit: `Entregar`,
  applications_auto_verified_against_funder_criteria: `solicitudes, verificadas automáticamente según los criterios del financiador.`,
  share: `Compartir`,
  content_track_impact_and_capture_funder_feedback: `contenido, realizar un seguimiento del impacto y captar los comentarios de los financiadores.`,
  here: `aquí`,
  please_enter_password: `Por favor ingrese la Contraseña`,
  ok: `De acuerdo`,
  confirm_email: `Confirmar correo electrónico`,
  log_in: `Acceso`,
  please_enter_email: `Por favor ingrese el correo electrónico`,
  the_input_is_not_valid_email: `¡La entrada no es un correo electrónico válido!`,
  the_new_password_that_you_entered_do_not_match: `¡La nueva contraseña que ingresó no coincide!`,
  the_new_email_that_you_entered_do_not_match: `¡El nuevo correo electrónico que ingresaste no coincide!`,
  please_confirm_your_password: `Por favor ingrese Confirmar Contraseña`,
  please_accept_the_user_terms: `Por favor acepte los Términos de Usuario`,
  change_password: `Cambiar la contraseña`,
  password: `Contraseña`,
  we_just_emailed: `acabamos de enviar un correo electrónico`,
  please_click_on_the_link_in_your_email_to_activate_your_account: `Haga clic en el enlace de su correo electrónico para activar su cuenta.`,
  please_enter_a_valid_password: `Por favor ingrese una contraseña válida`,
  you_have_been_logged_out_due_to_inactivity: `Te has desconectado por inactividad...`,
  please_enter_a_valid_password_using_the_guidance_below: `Error: ingrese una contraseña válida siguiendo las instrucciones a continuación.`,
  entity: `Entidad`,
  unique_visitors: `Visitantes únicos`,
  questions: `Preguntas`,
  localQuestions: `Preguntas locales`,
  visitors: `Visitantes`,
  visitor_id: `Identificación de visitante`,
  answer: `Respuesta`,
  question_time: `turno de preguntas`,
  avg_question_per_visitor: `Promedio Pregunta por visitante`,
  media: `Medios de comunicación`,
  logo: `Logo`,
  profile_create: `Crear perfil`,
  lets_get_started: `Empecemos`,
  name_and_location: `Nombre y ubicación`,
  what_is_the_legal_Name_of_your_entity: `¿Cuál es el Nombre Legal de su entidad?`,
  what_entity_name_would_like_to_be_displayed: `¿Qué nombre de entidad le gustaría que se mostrara?`,
  what_is_your_registered_address: `¿Cuál es su dirección registrada?`,
  description: `Descripción`,
  add_your_description: `Añade tu descripción`,
  add_your_social_media_details: `Añade los detalles de tus redes sociales`,
  what_is_your_website: `¿Cuál es su sitio web?`,
  optional: `Opcional`,
  add_your_company_logo: `Añade el logo de tu empresa`,
  upload: `Subir`,
  organization_profile: `Perfil de la organización`,
  description_company: `Descripción`,
  detail: `Detalle`,
  registered_address: `Dirección registrada`,
  proceed: `Proceder`,
  previous: `Anterior`,
  save_n_exit: `Guardar y salir`,
  next: `Próximo`,
  enter: `Ingresar`,
  complete: `Completo`,
  my_details: `Mis detalles`,
  your_name: `Su nombre`,
  phone_number: `Número de teléfono`,
  job_title: `Título profesional`,
  biz_give_role: `BizDar rol`,
  member_since: `Miembro desde`,
  my_programmes: `Mis programas`,
  delete_file_confirmation: `Confirmación de eliminación de archivos`,
  please_confirm_you_are_happy_to_permanently_delete_this_file: `Confirme que está dispuesto a eliminar permanentemente este archivo.`,
  delete: `Borrar`,
  cancel: `Cancelar`,
  create_password: `Crear contraseña`,
  invite_new_user: `Invitar nuevo usuario`,
  regular_users: `Usuarios habituales`,
  can_not_view_or_edit_anything_by_default: `No se puede ver ni editar nada de forma predeterminada. Todos los usuarios invitados comienzan con este estado. Puede agregarlos a Programas para ver o editar ese programa específico y el contenido relacionado.`,
  organization_admins: `Administradores de la organización`,
  can_access_and_edit_everything_in_the_platform: `Puede acceder y editar todo en la plataforma. Puede asignar este privilegio a usuarios existentes en esta pantalla.`,
  user_name: `Nombre de usuario`,
  make_admin: `Hacer administrador`,
  remove_admin: `Eliminar administrador`,
  invited: `INVITADO`,
  regular: `REGULAR`,
  admin: `ADMINISTRACIÓN`,
  remove_user_from_your_organization: `Eliminar usuario de su organización`,
  please_confirm_you_are_to_permanently_remove_this_user: `¿Confirma que desea eliminar permanentemente a este usuario?`,
  none_of_their_programmes_or_interaction_data_will_be_removed: `Ninguno de sus programas o datos de interacción serán eliminados.`,
  remove_user: `Eliminar usuario`,
  remove_admin_rights: `Eliminar derechos de administrador`,
  remove: `Eliminar`,
  as_an_Organization_Admin: `como administrador de la organización.`,
  they_will_then_only_be_able_to_view_and_edit_programmes_that_they_manage: `Entonces sólo podrán ver y editar los programas que administren.`,
  enter_email_address: `Introduzca la dirección de correo electrónico`,
  confirm_email_address: `Confirmar el correo`,
  invite: `Invitar`,
  add_admin_rights: `Agregar derechos de administrador`,
  make: `Hacer`,
  an_organization_admin: `un administrador de organización`,
  they_will_be_able_to_view_and_edit_everything_in_your_organization: `Podrán ver y editar todo en su organización.`,
  charity_can_not_view_or_edit_anything_by_default: `No se puede ver ni editar nada de forma predeterminada. Todos los usuarios invitados comienzan con este estado. Puede agregarlos a aplicaciones para ver o editar esa aplicación específica y el contenido relacionado.`,
  charity_can_access_and_edit_everything_in_the_platform: `Puede acceder y editar todo en la plataforma. Puede asignar este privilegio a usuarios existentes en esta pantalla.`,
  none_of_their_applications_or_interaction_data_will_be_removed: `Ninguna de sus aplicaciones o datos de interacción serán eliminados.`,
  they_will_then_only_be_able_to_view_and_edit_applications_that_they_manage: `Entonces sólo podrán ver y editar las aplicaciones que administren.`,
  the_invited_user_already_has_an_account_linked_to_this_email_address: `El usuario invitado ya tiene una cuenta vinculada a esta dirección de correo electrónico. Consulte su lista de usuarios o comuníquese con BizGive para obtener ayuda.`,
  all_programmes: `Todos los programas`,
  download: `Descargar`,
  search_placeholder: `Buscar...`,
  actions_required: `Acciones requeridas`,
  opportunity: `Oportunidad`,
  date_applied: `Fecha de solicitud`,
  date_requested: `Fecha solicitada`,
  net_vote: `Voto neto (votantes)`,
  date_approved: `Fecha de aprobación`,
  date_declined: `Fecha rechazada`,
  applied: `APLICADO`,
  in_edit: `EN EDITAR`,
  pre_approved_caps: `PREAPROBADO`,
  approved_caps: `APROBADO`,
  declined_caps: `RECHAZADO`,
  review: `Revisar`,
  customize_your_download: `Personaliza tu descarga`,
  select_application_status: `Seleccione el estado de la solicitud`,
  share_and_manage_voting: `Compartir y gestionar la votación`,
  current_share_access_closing_date: `Fecha de cierre de acceso a acciones actual`,
  invited_users_will_receive_an_email_with_access_details: `Los Usuarios invitados recibirán un correo electrónico con los datos de acceso, accesibles hasta la Fecha de Cierre. Sólo podrán ver sus votos.`,
  invited_voters: `Votantes invitados`,
  add_email_address: `Agregar dirección de correo electrónico`,
  reported_grants: `Subvenciones reportadas`,
  planned_grants: `Subvenciones planificadas`,
  remaining_budget: `Presupuesto restante`,
  total_budget: `Presupuesto total`,
  do_you_wish_to_request_indicators: `¿Desea solicitar indicadores?`,
  the_entity_will_be_asked_to_create: `Se pedirá a la entidad que cree indicadores para su oportunidad alineados con los resultados seleccionados.`,
  please_confirm_you_wish_to_complete_this_item: `Este paso está completo.`,
  requested: `Solicitado`,
  do_you_wish_the_applicant_to_create_indicators_to_measure_its_progress: `¿Desea que el solicitante cree indicadores para medir su progreso?`,
  volunteering: `Voluntariado`,
  day: `Día`,
  inkind: `en especie`,
  budget_period_end: `Fin del período presupuestario`,
  budget_available: `Presupuesto disponible`,
  budget_amount: `Monto del presupuesto`,
  remaining: `Restante`,
  select_filter: `Por favor seleccione un filtro`,
  donation_title: `Donación`,
  email_id_title: `ID de correo electrónico`,
  add_user: `Agregar usuario`,
  delete_title: `Borrar`,
  add_title: `Agregar`,
  delete_user: `Eliminar usuario`,
  action_cannot_undone: `Esta acción no se puede deshacer. Los administradores de cuentas seguirán accediendo a cualquier oportunidad que administren.`,
  confirm_title: `Confirmar`,
  adding_admin_rights: `Agregar derechos de administrador le brinda al usuario la posibilidad de crear oportunidades, actualizar el perfil de la organización, agregar y eliminar usuarios y crear administradores.`,
  remove_admin_rights_para: `Al eliminar los derechos de administrador, se elimina la capacidad del usuario de crear oportunidades, actualizar el perfil de la organización, agregar y eliminar usuarios y crear administradores.`,
  save_private: `Guardado (Privado)`,
  planned_shared: `Planificado (compartido)`,
  invoice_requested: `Factura solicitada`,
  invoice_received: `Factura recibida`,
  reported_title: `Reportado`,
  confirmed_title: `Confirmado`,
  report_donation: `Reportar donación`,
  cancel_title: `Cancelar`,
  save_title: `Ahorrar`,
  grant: `Conceder`,
  awarded: `Premiado`,
  award_title: `Otorgar`,
  type_title: `Tipo`,
  invoice_title: `Factura`,
  condition_title: `Condición`,
  reported_date_title: `Fecha reportada`,
  next_action_title: `Siguiente acción`,
  donation_created: `Éxito - donación creada`,
  donation_updated: `Éxito - donación actualizada`,
  donation_deleted: `Éxito: donación eliminada`,
  view_donation: `Ver donación`,
  select_title: `Seleccionar`,
  approved_opportunities_planned_impact: `Oportunidades aprobadas (impacto planificado)`,
  achieved_impact: `Impacto logrado (oportunidades completadas)`,
  achieved_beneficiaries: `Beneficiarios alcanzados`,
  outputs_achieved: `Resultados obtenidos`,
  content_received: `Contenido recibido (impacto logrado)`,
  opportunity_name: `Nombre de la oportunidad`,
  entity_name: `Nombre de la entidad`,
  due_date: `Fecha de vencimiento`,
  number: `Número`,
  approved_date: `Fecha aprobada`,
  view: `Vista`,
  primary_UN_SDG: `ODS primario de la ONU `,
  opportunity_type: `Tipo de oportunidad`,
  charity_name: `Nombre de la organización benéfica`,
  select_type: `Por favor seleccione un tipo`,
  please_fill_amount: `Por favor complete la cantidad`,
  enter_title: `Ingresar`,
  please_enter_conditions: `por favor ingrese la condición`,
  please_select_action: `Por favor seleccione una acción`,
  actions_title: `Comportamiento`,
  select_action: `Seleccionar acción`,
  payment_reference: `Referencia de pago`,
  please_select_amount: `Por favor seleccione una cantidad`,
  enter_payment_reference: `Ingrese la referencia de pago`,
  upload_counterpart_behalf: `Cargar factura en nombre de la contraparte`,
  equivalent_value: `Valor equivalente`,
  amount_title: `Cantidad`,
  purchase_order: `Orden de compra`,
  files_title: `Archivos`,
  company_name_title: `nombre de empresa`,
  programme_type_title: `Tipo de programa`,
  application_start_date: `Fecha de inicio de la solicitud`,
  application_end_date: `Fecha de finalización de la solicitud`,
  location_title: `Ubicación`,
  next_update_outcome: `Próxima actualización/resultado`,
  donations_by: `Donaciones por`,
  decision_date: `Fecha de decisión`,
  decision_start_date: `Fecha de inicio de la decisión`,
  decision_end_date: `Fecha de finalización de la decisión`,
  opportunity_i_manage: `Oportunidades que administro`,
  select_template: `Seleccionar plantilla`,
  please_select_template: `Por favor seleccione una plantilla`,
  save_draft: `Guardar borrador`,
  all_opportunities: `Todas las oportunidades`,
  excel_title: `Sobresalir`,
  budget_period: `Período presupuestario`,
  latest_period: `Último período`,
  select_donation_status: `Seleccione el estado de la donación`,
  delete_file: `Eliminar archivo`,
  deleting_file_para: `Eliminar este archivo lo eliminará permanentemente`,
  delete_donation: `Eliminar donación`,
  delete_donation_para: `Al eliminar esta donación se eliminará toda la información relacionada de forma permanente.`,
  cancel_changes: `Cancelar cambios`,
  remove_title: `Eliminar`,
  will_remove_changes_to_donation: `Esto eliminará cualquier cambio realizado en la donación.`,
  edit_title_uppercase: `EDITAR`,
  current_report_period: `Período de informe actual`,
  current_report_open: `Informe actual abierto`,
  current_report_close: `Informe actual Cerrar`,
  manage_title: `Administrar`,
  open_date: `Fecha de apertura`,
  close_date: `Fecha de cierre`,
  period_title: `Período`,
  reporter_title: `Reportero`,
  edit_title: `Editar`,
  about_me: `Acerca de mí`,
  please_enter_valid_name: `Por favor ingresa un nombre válido`,
  please_enter_only_alphabets: `Por favor ingrese solo alfabetos`,
  name_Title: `Nombre`,
  phone_number_title: `Número de teléfono`,
  upload_purchase_order: `Cargar orden de compra`,
  programme_dates: `Fechas del programa`,
  programme_start: `Inicio del programa`,
  programme_end: `Fin del programa`,
  currency: `Divisa`,
  current_budget_year_end: `Fin del año presupuestario actual:`,
  approved_summary: `Resumen aprobado`,
  please_select_programme: `Por favor seleccione un programa`,
  generate: `Generar`,
  opportunities_supported: `Oportunidades apoyadas`,
  approved_opportunities: `Oportunidades aprobadas`,
  planned_impact: `Impacto planificado (oportunidades aprobadas)`,
  grants: `Subvenciones`,
  planned_beneficiaries: `Beneficiarios previstos`,
  direct: `Directo`,
  indirect: `Indirecto`,
  primary: `Primario`,
  secondary: `Secundario`,
  all: `Todo`,
  programme_name: `Nombre del programa`,
  reset: `Reiniciar`,
  my_feedback: `Mis comentarios`,
  feedback_title: `Comentario`,
  select_opportunity: `Seleccionar oportunidad`,
  please_select_opportunity: `Por favor seleccione una oportunidad`,
  select_report: `Seleccionar informe`,
  please_select_report: `Por favor seleccione un informe`,
  editing_title: `Edición`,
  enabled_title: `Activado`,
  locked_title: `bloqueado`,
  content_title_uppercase: `CONTENIDO`,
  feedback_title_uppercase: `COMENTARIO`,
  no_data: `Sin datos`,
  program_status: `Estado del programa`,
  un_sdgs: `ODS de la ONU`,
  more_title: `Más`,
  program_location: `Ubicación del programa`,
  asset_name: `Nombre del activo`,
  asset_location: `Ubicación de activos`,
  portfolio_title: `Cartera`,
  review_title: `Revisar`,
  payment_date: `Fecha de pago`,
  secondary_UN_SDG: `ODS secundarios de la ONU`,
  summary_title: `Resumen`,
  select_the_programme_you_wish_to_receive: `Seleccione el programa del que desea recibir un informe sobre el activo seleccionado anteriormente.`,
  manager: `Gerente`,
  add_managers_who_can_invite_reporter: `Agregue administradores que puedan invitar a periodistas en su nombre. Nota: Los usuarios internos de su organización se pueden agregar desde su`,
  admin_page: `página de administración`,
  inviting_existing_user: `Invitar a un usuario existente`,
  invite_new: `invitar a nuevos`,
  external_users: `usuarios externos`,
  by_entering_their_email_address: `ingresando su dirección de correo electrónico`,
  optional_add_reporters: `Opcional. Agregue reporteros que completarán los informes del programa para sus activos.`,
  manage_report: `Administrar informe`,
  add_asset: `Agregar activo`,
  budget_history: `Historia del presupuesto`,
  milestones: `Hitos`,
  programme_name_title: `Nombre del programa`,
  application: `Solicitud`,
  create: `Crear`,
  comment_title: `Comentario`,
  cash_donation_saved_successfully: `Donación en efectivo guardada.`,
  upload_invoice: `Cargar factura`,
  upload_title: `Subir`,
  confirm_receipt: `Confirmar recibo`,
  received_title: `Recibió`,
  please_confirm_donation_received: `Por favor confirme que esta donación ha sido recibida.`,
  success_donation_received: `Éxito - donación recibida`,
  success_invoice_uploaded: `Éxito: factura cargada`,
  click_to_upload: `Haga clic para cargar`,
  settings: `Ajustes`,
  internal_only: `Sólo interno`,
  visibility_title: `Visibilidad`,
  public_title: `Público`,
  private: `Privado`,
  completed: `Terminado`,
  content_package: `Paquete de contenido`,
  please_select_interaction_status: `Seleccione el estado de la interacción.`,
  go_back: `Volver`,
  budget_dates: `Fechas del presupuesto`,
  budget_recurring: `¿Presupuesto recurrente?`,
  objectives: `Objetivos`,
  supporting_materials: `Material de apoyo`,
  web_links: `Enlaces web`,
  administrators: `Administradores`,
  application_criteria: `Criterios de solicitud`,
  documentation_required: `Documentación requerida`,
  available_support: `Soporte disponible`,
  none: `Ninguno`,
  eligibility_checklist: `Lista de verificación de elegibilidad`,
  location_supported: `Ubicación admitida`,
  project_must_be_within: `El proyecto debe estar dentro`,
  of_this_location: `de esta ubicación`,
  expand_all: `Expandir todo`,
  entities_supported: `Entidades apoyadas`,
  mandatory: `Obligatorio`,
  expected_budget: `Presupuesto esperado`,
  per_opportunity: `Por proyecto`,
  specific_skills_available: `Habilidad específica disponible`,
  general_skills_available: `Habilidades generales disponibles`,
  any: `Cualquier`,
  application_accepted_between: `Solicitudes aceptadas`,
  donation_to_be_made_between: `Donación a realizarse`,
  interim_update_requested: `Actualización provisional solicitada`,
  final_report_requested: `Informe final solicitado`,
  show_all_goals: `Mostrar todos los objetivos`,
  any_location: `Cualquier ubicación`,
  apply: `Aplicar`,
  eligibility: `Elegibilidad`,
  before_applying_please_confirm_your_eligibility: `Antes de presentar la solicitud, confirme su elegibilidad:`,
  please_confirm_that_your_project_is_located_within_or_that_it_benefits_those_within_the_supported_locations: `Confirme que su proyecto está ubicado dentro de las ubicaciones admitidas o que beneficia a quienes se encuentran dentro de ellas.`,
  please_select: `Por favor seleccione`,
  project_description: `Descripción del proyecto`,
  please_share_a_summary_of_your_project: `Por favor comparte un resumen de tu proyecto.`,
  enter_project_summary: `Ingrese el resumen del proyecto`,
  please_describe_your_project: `Por favor describe tu proyecto`,
  for_example_what_do_you_want_to_do: `Por ejemplo, ¿qué quiere hacer, cómo lo hará, ha identificado una necesidad para el proyecto y quién lo liderará?`,
  this_application_is_to: `Esta aplicación es para:`,
  application_accepted: `Solicitudes aceptadas:`,
  application_sections: `Secciones de aplicaciones`,
  application_preview: `Vista previa de la aplicación`,
  application_guidance: `Guía de aplicación`,
  in_the_application_form: `En el formulario de solicitud, se le pedirá que comparta los detalles del proyecto para el que solicita financiación.`,
  next_title: `'Próximo'`,
  save_n_exit_title: `'Guardar y salir'`,
  submit_title: `'Entregar'`,
  saves_your_data_and_moves: `guarda sus datos y lo lleva a la siguiente pantalla en el formulario de solicitud. Tus respuestas se guardarán automáticamente, a menos que tengas un problema de conectividad a Internet.`,
  saves_your_data_and_closes: `guarda sus datos y cierra el formulario de solicitud, para que pueda volver a él más tarde. Deberá completar todos los campos obligatorios para "Guardar y salir" (puede ingresar valores aleatorios, por ejemplo, X como marcador de posición, para cl`,
  saves_your_data_and_closes_the_report: `guarda sus datos y cierra el informe, para que pueda volver a él más tarde. Deberá completar todos los campos obligatorios para "Guardar y salir" (puede ingresar valores aleatorios, por ejemplo, X como marcador de posición)`,
  sends_your_application_form_to_the_company: `envía su formulario de solicitud a la empresa. Este botón aparece en la pantalla final del formulario de solicitud.`,
  to_access_a_saved_application: `Para acceder a una aplicación guardada: haga clic en Aplicaciones y acción requerida.`,
  to_view_a_submitted_application: `Para ver una solicitud enviada: haga clic en Solicitudes y respuesta pendiente`,
  start: `Comenzar`,
  application_form: `Formulario de solicitud`,
  your_application: `Su solicitud`,
  what_is_the_name_of_your_project: `¿Cómo se llama tu proyecto?`,
  please_complete_each_screen: `Complete cada pantalla del formulario de solicitud. En la última pantalla, verá una vista previa de su solicitud y desde aquí puede hacer clic en "Enviar" para enviarla a la empresa.`,
  project_name: `Nombre del proyecto`,
  add_a_banner_image: `Agregar una imagen de banner`,
  this_will_show_at_the_top_of_your_application_form: `Esto se mostrará en la parte superior de su formulario de solicitud completado.`,
  choose_an_image_from_bizGive: `Elija una imagen de BizGive`,
  upload_your_own_banner_image: `Sube tu propia imagen de banner`,
  additional_images: `Imágenes adicionales`,
  bizGive_images: `BizDar imágenes`,
  where_is_your_project_located: `¿Dónde está ubicado su proyecto?`,
  search_for_and_select_the_address_of_your_location: `Busque y seleccione la dirección de su(s) ubicación(es). O alternativamente,`,
  click: `hacer clic`,
  any_place_or_point_on_the_map_to_select_it: `cualquier lugar o punto del mapa para seleccionarlo.`,
  add_or_Edit_the_name_for_your_location_and_press: `Agregue o edite el nombre de su ubicación y presione "Agregar otro" para agregar más ubicaciones.`,
  add_additional_location: `Agregar ubicación adicional`,
  one_or_more_project_locations_are_located_outside_of_the_programme_area: `Una o más ubicaciones del proyecto están ubicadas fuera del área del programa.`,
  please_change_your_project_location_or_explain_how_your_project_will_benefit_the_programme_area_below: `Cambie la ubicación de su proyecto O explique cómo su proyecto beneficiará el área del programa a continuación`,
  how_will_it_benefit_the_programme_area: `¿Cómo beneficiará al área del programa?`,
  project_dates: `Fechas del proyecto`,
  when_is_your_project_happening: `¿Cuándo se realizará tu proyecto?`,
  this_can_be_an_estimate: `Esto puede ser una estimación, ya que se le pedirá que edite o confirme sus fechas si su solicitud es exitosa.`,
  projects_must_start_within_12_months: `Los proyectos deben comenzar dentro de los meses de oportunidadStartWithinMonths.`,
  projects_must_not_be_longer_than_6_months: `Los proyectos no deben durar más de meses de oportunidadLongitudMeses.`,
  estimated_start: `Inicio estimado`,
  estimated_finish: `Final estimado`,
  is_there_a_deadline_when_you_need_to_receive_a_donation_by: `¿Existe una fecha límite en la que debes recibir una donación para que tu proyecto pueda seguir adelante?`,
  if_not_please_leave_this_blank: `Si no, déjelo en blanco.`,
  enter_date: `Introducir fecha`,
  what_support_are_you_applying_for: `¿Qué apoyo estás solicitando?`,
  in_kind: `en especie`,
  how_much_are_you_applying_for: `¿Cuánto estás solicitando?`,
  enter_amount: `Ingrese el monto`,
  how_much_does_your_project_cost_in_total: `¿Cuánto cuesta su proyecto en total?`,
  you_are_applying_for_percentage_of_the_total_cost_of_your_project: `Estás solicitando un porcentaje del coste total de tu proyecto.`,
  how_will_you_use_any_support_awarded: `¿Cómo utilizará el apoyo otorgado?`,
  enter_number_of_items_or_activity: `Ingrese el número de artículos o actividad`,
  enter_description: `Introduce la descripción`,
  where_will_additional_funds_come_from: `¿De dónde vendrán los fondos adicionales?`,
  internal_resources: `Recursos internos`,
  external_funding: `Financiamiento externo`,
  have_you_already_secured_this_funding: `¿Ya ha obtenido esta financiación?`,
  can_your_project_proceed_if_you: `¿Puede su proyecto continuar si no obtiene esta financiación adicional?`,
  what_outputs_will_the_support_help_you_to_achieve: `¿Qué resultados le ayudará a lograr el apoyo?`,
  your_outputs_will_show_like_this_in_your_application_form: `Sus resultados se mostrarán así en su formulario de solicitud:`,
  what_items_or_services_do_you_need: `¿Qué artículos o servicios necesitas?`,
  for: `para`,
  what_volunteering_support_do_you_need: `¿Qué apoyo de voluntariado necesitas?`,
  edit_image: `Editar imagen`,
  change_image: `Cambiar imagen`,
  delete_image: `Eliminar imagen`,
  click_delete_to_remove_this_image: `Haga clic en "Eliminar" para eliminar esta imagen.`,
  option: `Opción`,
  add: `Agregar`,
  tips: `Consejos`,
  what_is_an_output: `¿Qué es una salida?`,
  an_output_is_what_you_expect_to_achieve_from_the_support_awarded_below_are_some_examples: `Un resultado es lo que espera lograr con el apoyo otorgado. A continuación se muestran algunos ejemplos:`,
  number_new_teaching_assistants_trained: `5 nuevos asistentes docentes capacitados`,
  number_new_teachers_trained: `10 nuevos docentes capacitados`,
  number_workshops_hosted: `3 talleres organizados`,
  number_energy_audits_completed: `4 auditorías energéticas completadas`,
  number_people_more_aware_of_climate_change_in_our_community: `200 personas más concienciadas sobre el cambio climático en nuestra comunidad`,
  number_new_playground_installed: `1 nuevo parque infantil instalado`,
  please_enter: `Por favor ingresa`,
  which_of_the_company_impact_objectives_will_your_project_support: `¿Cuáles de los objetivos de impacto de la empresa respaldará su proyecto?`,
  what_outcomes_do_you_hope_your_project_will_achieve: `¿Qué resultados espera que logre su proyecto?`,
  what_is_an_outcome: `¿Qué es un resultado?`,
  an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples: `Un resultado es el cambio que espera ver como resultado de su proyecto. A continuación se muestran algunos ejemplos.`,
  objective_protect_and_improve_the_local_environment: `Objetivo: Proteger y Mejorar el Medio Ambiente Local`,
  outcome_improve_fish_populations_through_river_restoration: `Resultado: Mejorar las poblaciones de peces mediante la restauración de los ríos.`,
  objective_create_and_improve_local_amenities: `Objetivo: crear y mejorar los servicios locales`,
  outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows: `Resultado: Mejorar la eficiencia energética del ayuntamiento con nuevas ventanas.`,
  objective_engage_the_local_community: `Objetivo: involucrar a la comunidad local`,
  outcome_reduce_isolation_and_loneliness_in_older_people: `Resultado: Reducir el aislamiento y la soledad en las personas mayores.`,
  how_will_you_achieve_these_outcomes: `¿Cómo logrará estos resultados?`,
  briefly_describe_your_approach_to_achieving_the_outcomes: `Describa brevemente su enfoque para lograr los resultados.`,
  below_are_some_examples: `A continuación se muestran algunos ejemplos:`,
  we_will_remove_excess_silt: `Eliminaremos el exceso de limo, para que se restablezcan las zonas de reproducción de los peces.`,
  we_will_replace_our_old_windows_with_triple_glazed_windows: `Reemplazaremos nuestras viejas ventanas por ventanas de triple acristalamiento.`,
  we_will_run_weekly_workshops_bringing_older_people_together: `Realizaremos talleres semanales que reunirán a personas mayores.`,
  how_will_you_achieve_this_outcome: `¿Cómo logrará este resultado?`,
  please_use_no_more_than_25_words_as_you_will_be_asked_to_describe_your_approach_on_the_next_screen: `No utilice más de 25 palabras, ya que se le pedirá que describa su enfoque en la siguiente pantalla.`,
  enter_outcome: `Introduzca el resultado`,
  please_enter_numeric_value: `Por favor ingrese el valor numérico`,
  expected_decision_date: `Fecha prevista de decisión`,
  beneficiaries: `Beneficiarios`,
  who_or_what_will_benefit_from_your_project: `¿Quién o qué se beneficiará de su proyecto?`,
  who_are_the_social_beneficiaries: `¿Quiénes son los beneficiarios sociales?`,
  select_beneficiary_type: `Seleccione el tipo de beneficiario`,
  how_many_people_will_benefit: `¿Cuántas personas se beneficiarán?`,
  direct_beneficiaries: `Beneficiarios directos`,
  enter_estimated_number: `Ingrese el número estimado`,
  indirect_beneficiaries: `Beneficiarios indirectos`,
  how_will_the_environment_benefit: `¿Cómo se beneficiará el medio ambiente?`,
  for_example_species_of_new_plants_introduced_ppm_of_CO2_reduced_terrestrial_animals_protected: `Por ejemplo, se introdujeron 10 especies de nuevas plantas, se redujeron 10 ppm de CO2, se protegieron 10 animales terrestres.`,
  select_type_title: `Seleccionar tipo`,
  select_sub_type: `Seleccionar subtipo`,
  select_units: `Seleccionar unidades`,
  your_environmental_beneficiaries_will_show_like_this_in_your_application_form: `Tus beneficiarios ambientales se mostrarán así en tu formulario de solicitud:`,
  environmental_beneficiaries: `Beneficiarios ambientales`,
  the_environmental_beneficiaries_drop_down_fields_enable_you_to_share_additional_details: `Los campos desplegables de beneficiarios ambientales le permiten compartir detalles adicionales, como si está apoyando especies, hábitats o edificios, plantas o animales y qué acciones está `,
  select_type_title_head: `Seleccione tipo:`,
  choose_whether_your_project_supports_habitats_such_as_forests_or_woodlands: `Elija si su proyecto respalda hábitats, como bosques o zonas arboladas, especies, como plantas o animales, o edificios, como escuelas o edificios comunitarios compartidos, como un ayuntamiento.`,
  select_sub_type_head: `Seleccione Subtipo:`,
  choose_the_type_of_habitat_species_or_building_you_are_supporting: `Elige el tipo de hábitat, especie o edificio que estás apoyando. Por ejemplo, seleccione agua dulce si apoya ríos o lagos.`,
  select_action_head: `Seleccionar acción:`,
  choose_the_type_of_action_you_re_taking_to_support_the_species: `Elija el tipo de acción que está tomando para apoyar la especie, el hábitat o el edificio. Por ejemplo, seleccione protegido si está protegiendo especies en peligro de extinción, restaurado si está regenerando un hábitat`,
  enter_amount_head: `Ingrese el monto:`,
  for_species_estimate_how_many_plants_or_animals_you_re_supporting_through_your_project: `Para las especies, calcule cuántas plantas o animales está apoyando a través de su proyecto.`,
  for_habitats_estimate_how_many_habitats_you_re_supporting_number_or_the_total_area_in_hectares: `Para los hábitats, calcule cuántos hábitats apoya (número) o el área total (en hectáreas).`,
  for_buildings_estimate_how_many_buildings_you_re_supporting: `Para los edificios, calcule cuántos edificios está apoyando (número) o cuánto está reduciendo energía, agua o gases de efecto invernadero (toneladas de equivalentes de CO2 (CO2e)).`,
  select_units_head: `Seleccione unidades:`,
  number_is_an_estimate_of_the_total_number_of_habitats_species_or_buildings_you_plan_to_support: `El número es una estimación del número total de hábitats, especies o edificios que planea mantener.`,
  hectares_is_an_estimate_of_the_total_area_of_a_habitat_youre_supporting: `Las hectáreas son una estimación del área total de un hábitat que estás sustentando.`,
  social_beneficiaries: `Beneficiarios Sociales`,
  select_the_type_of_beneficiaries_your_project_supports: `Seleccione el tipo de beneficiarios que apoya su proyecto. Luego, calcule el número total de beneficiarios que planea apoyar en todos los tipos de beneficiarios.`,
  direct_beneficiaries_head: `Beneficiarios directos:`,
  the_number_of_people_who_directly_benefit_from_your_opportunity: `La cantidad de personas que se benefician directamente de su oportunidad.`,
  indirect_beneficiaries_head: `Beneficiarios indirectos:`,
  the_number_of_people_whose_benefits_can_be_attributed_to_a_direct_beneficiary: `El número de personas cuyos beneficios pueden atribuirse a un beneficiario directo.`,
  for_example_if_your_project_supports_children_with_learning_disabilitie: `Por ejemplo, si su proyecto apoya a 10 niños con problemas de aprendizaje, los beneficiarios directos son esos 10 niños. Los beneficiarios indirectos son las familias de esos niños.`,
  habitats: `Hábitats`,
  forest: `Bosque`,
  deserts: `Desierto`,
  mountains: `Montaña`,
  coastal: `Costero`,
  marine: `Marina`,
  freshwater: `agua dulce`,
  polar: `Polar`,
  wetlands: `Humedales`,
  rainforest: `selva tropical`,
  arctic: `Ártico`,
  tundra: `Tundra`,
  restored: `Restaurado`,
  protected: `Protegido`,
  created: `Creado`,
  hectares: `Hectáreas`,
  established: `Establecido`,
  benefitted: `Beneficiado`,
  terrestrial_animals: `Animales terrestres`,
  aquatic_animals: `Animales Acuáticos`,
  terrestrial_plants: `Plantas Terrestres`,
  aquatic_plants: `Plantas Acuáticas`,
  species: `Especies`,
  select_category: `Seleccionar categoría`,
  select_sub_category: `Seleccionar subcategoría`,
  please_add_at_least_one_outcome_under_selected_objectives: `Agregue al menos 1 resultado bajo los objetivos seleccionados`,
  please_enter_your_approach_for_each_outcome: `Ingrese su enfoque para cada resultado.`,
  create_n_manage_sharing: `Crear y gestionar el uso compartido`,
  access_closing_date: `Fecha de cierre de acceso`,
  please_choose_closing_date: `Por favor elija la fecha de cierre`,
  newly_invited_users_will_receive_an_email_invitation: `Los usuarios recién invitados recibirán una invitación por correo electrónico.`,
  existing_invited_users_will_not_be_notified_of_changes: ` Los usuarios invitados existentes no serán notificados de los cambios.`,
  update: `Actualizar`,
  user_already_exists: `El usuario ya existe`,
  verify_your_email: `Verifique su correo electrónico`,
  please_verify_your_email_to_receive_a_magic_link: `Verifique su correo electrónico para recibir un enlace mágico para acceder a su Portal de comentarios.`,
  emissions: `Emisiones`,
  greenhouse_gases: `Gases de efecto invernadero`,
  reduced: `Reducido`,
  captured: `capturado`,
  prevented: `Prevenido`,
  tonnes_of_CO2_equivalents_C02e: `Toneladas de CO2 equivalentes (C02e)`,
  additional_questions: `Preguntas adicionales`,
  required_documents: `Documentos requeridos`,
  additional_files: `Archivos adicionales`,
  document_name: `Nombre del documento`,
  custom_question: `¿Pregunta personalizada?`,
  custom_questions: `Preguntas personalizadas`,
  enter_answer: `Ingrese la respuesta`,
  if_you_are_awarded_support_you_may_be_required_to_share_interim_Updates: `Si recibe soporte, es posible que deba compartir actualizaciones provisionales y un informe final único con la empresa. Recibirá una notificación por correo electrónico de BizGive cuando venzan.`,
  can_you_meet_the_required_submission_deadlines: `¿Puedes cumplir con los plazos de presentación requeridos?`,
  based_on_the_estimated_start_and_finish_date_of_your_project: `Según la fecha estimada de inicio y finalización de su proyecto, confirme que podría cumplir con los plazos de presentación a continuación. Podrás actualizar las fechas de tu proyecto si tu solicitud es adecuada.`,
  interim_updates: `Actualizaciones provisionales`,
  final_report: `Informe final`,
  this_value_cannot_be_lower_than_the_amount_you_are_applying_for: `Este valor no puede ser inferior al monto que estás solicitando.`,
  what_is_an_interim_update: `¿Qué es una actualización provisional?`,
  an_update_required_by_the_company_on_the_progress_of_your_project: `Una actualización requerida por la empresa sobre el avance de su proyecto.`,
  download_interim_update_report_template: `Descargar la plantilla de informe de actualización provisional`,
  what_is_a_final_report: `¿Qué es un informe final?`,
  a_single_report_required_by_the_company_on_what_your_project_achieved_with_the_support_provided: `Un informe único requerido por la empresa sobre lo que logró su proyecto con el apoyo brindado.`,
  download_final_report_template: `Descargar plantilla de informe final`,
  how_will_i_know_when_an_interim_update_or_final_report_is_due: `¿Cómo sabré cuándo vence una actualización provisional o un informe final?`,
  you_will_receive_an_email_notification_from_bizGive_when_the_deadline_is_approaching: `Recibirá una notificación por correo electrónico de BizGive cuando se acerque la fecha límite. Siga las instrucciones de estos correos electrónicos para completar y enviar estos informes a la empresa.`,
  contact_details: `Detalles de contacto`,
  after_submitting_your_application_you_will_receive_email_notifications_from_BizGive_on_its_status: `Después de enviar su solicitud, recibirá notificaciones por correo electrónico de BizGive sobre su estado.`,
  please_add_another_contact_in_case_of_your_absence: `Por favor agregue otro contacto en caso de su ausencia.`,
  if_theyre_already_on_BizGive_select_their_name_below: `Si ya están en BizGive, seleccione su nombre a continuación:`,
  invite_a_colleague_to_join_by_entering_their_email_address_below: `Invite a un colega a unirse ingresando su dirección de correo electrónico a continuación:`,
  select_user: `Seleccionar usuario`,
  what_is_an_indicator: `¿Qué es un indicador?`,
  an_indicator_is_a_measure_of_progress: `Un indicador es una medida de progreso. Incluye un objetivo e hitos para alcanzar este objetivo. Por ejemplo, la cantidad de personas a las que planeas ayudar y cómo aumentará con el tiempo.`,
  an_indicator_is_an_estimate: `Un indicador es una estimación, así que no te preocupes si tus planes cambian. Si se aprueba su solicitud, se le pedirá que actualice sus indicadores.`,
  indicator_examples: `Ejemplos de indicadores`,
  no_of_people_gaining_a_new_skill_or_qualification: `Número de personas que obtienen una nueva habilidad o cualificación`,
  no_of_workshops_hosted: `Número de talleres organizados`,
  decrease_in_local_unemployment: `% de disminución del desempleo local`,
  when_do_i_update_my_indicators: `¿Cuándo actualizo mis indicadores?`,
  if_your_application_is_approved: `Si se aprueba su solicitud, recibirá notificaciones por correo electrónico de BizGive cuando deba actualizar sus indicadores.`,
  how_often_do_I_update_my_indicators: `¿Con qué frecuencia actualizo mis indicadores?`,
  you_will_be_asked_to_update_your_indicators_at_the_same_time: `Se le pedirá que actualice sus indicadores al mismo tiempo que se le pedirá que envíe su actualización provisional o informe final.`,
  measuring_progress: `Medir el progreso`,
  objective_outcome_specific_indicators: `Indicadores específicos de objetivos/resultados`,
  mandatory_title: `Obligatorio`,
  about_your_project: `Acerca de su proyecto`,
  your_request: `Su Solicitud`,
  planned_impact_title: `Impacto planificado`,
  award_criteria: `Criterios de adjudicación`,
  step_1: `Paso 1`,
  step_2: `Paso 2`,
  step_3: `Paso 3`,
  step_4: `Paso 4`,
  step_5: `Paso 5`,
  submit_your_application: `Envíe su solicitud`,
  to_submit_your_application_you_must_read_and_agree_to_the_application: `Para enviar su solicitud debe leer y aceptar la solicitud.`,
  terms_and_conditions: `Términos y condiciones`,
  below: `abajo.`,
  please_note_you_will_not_be_able_to_edit_your_application_after_it_has_been_submitted_unless_requested_to_by_the_company_youre_applying_to: `Tenga en cuenta que no podrá editar su solicitud una vez enviada, a menos que lo solicite la empresa a la que se postula.`,
  by_submitting_this_application_you_will_be_sharing_your_application_user_details_and_ongoing_entity_profile_information_with_the_funder: `Al enviar esta solicitud, compartirá su solicitud, los detalles del usuario y la información actual del perfil de la entidad con el financiador.`,
  enter_caption: `Introduzca el título...`,
  impact_alignment: `Alineación de impacto`,
  approve: `Aprobar`,
  decline: `Rechazar`,
  requested_support: `Soporte solicitado`,
  total_request: `Solicitud total`,
  total_project_budget: `Presupuesto total del proyecto`,
  funder_contribution: `Contribución del financiador`,
  planned_expenditure: `Gasto planificado`,
  additional_funding: `Financiamiento adicional`,
  additional_funding_is_required_to_meet_the_total_opportunity_budget: `Se requiere financiación adicional para cumplir con el presupuesto total de oportunidad.`,
  where_will_additional_funds_be_sourced: `¿De dónde se obtendrán fondos adicionales?`,
  has_this_funding_been_secured: `¿Se ha asegurado esta financiación?`,
  can_this_project_go_ahead_without_additional_funding: `¿Puede este proyecto seguir adelante sin financiación adicional?`,
  outputs: `Salidas`,
  you_must_select_yes_to_proceed: `Debes seleccionar sí para continuar`,
  please_enter_the_dates_within_the_above_mentioned_limits: `Por favor ingrese las fechas dentro de los límites mencionados anteriormente.`,
  at_least_one_checkbox_must_be_selected: `Se debe seleccionar al menos una casilla de verificación`,
  delete_confirmation: `Eliminar confirmación`,
  unchecking_this_box_will_delete_any_underlying_data_you_have_entered_for_this_objective_or_outcome: `Al desmarcar esta casilla se eliminarán todos los datos subyacentes que haya ingresado para este objetivo o resultado.`,
  at_least_one_outcome_must_be_selected: `Se debe seleccionar al menos 1 resultado`,
  please_select_at_least_one_objective: `Por favor seleccione al menos 1 objetivo`,
  project_timelines: `Cronogramas del proyecto`,
  project_location: `Ubicación del proyecto`,
  pending_title: `Pendiente`,
  view_indicator: `Ver indicador`,
  indicators_status_confirmation: `Estado de los indicadores Confirmación`,
  indicators_successfully_submitted: `Indicadores enviados exitosamente`,
  please_create_at_least_indicator_outcome: `Cree al menos un indicador por resultado`,
  please_complete_n_delete_pending_indicators: `Por favor complete o elimine los indicadores pendientes`,
  modal_will_be_closed_after_two_seconds: `El modal se cerrará después de dos segundos.`,
  please_enter_indicatorInterimActual: `Por favor ingrese el indicadorInterimActual`,
  no_comments: `Sin comentarios`,
  enter_final_total: `Ingrese el total final`,
  milestone_date: `Fecha del hito`,
  accumulative_target: `Objetivo acumulativo`,
  actuals: `Datos reales`,
  evidence: `Evidencia`,
  total_target: `Objetivo total`,
  please_enter_total_accumulative_target: `Por favor ingrese el objetivo total acumulativo`,
  please_add_value_for_historic_milestone: `Por favor agregue un valor para cada hito histórico`,
  cancel_uppercase: `CANCELAR`,
  submit_uppercase: `ENTREGAR`,
  press_submit_to_confirm: `Presione Enviar para confirmar su entrada. Tenga en cuenta que esto se compartirá con`,
  confirmation: `Confirmación`,
  your_donor_n_can_not_be_edited: `su donante y no se puede editar`,
  indicator_name: `Nombre del indicador`,
  please_enter_indicator_name: `Por favor ingrese el nombre del indicador`,
  main_focus: `Enfoque principal`,
  social_n_beneficiaries: `Sociales / Beneficiarios`,
  please_select_beneficiaries: `Por favor seleccione los beneficiarios`,
  please_enter_unit: `Por favor ingrese la unidad`,
  how_will_you_measure_progress: `¿Cómo medirá el progreso?`,
  starting_number_level_indicator: `Número/nivel inicial de su indicador`,
  if_you_do_not_know_this_then_enter_zero: `Si no lo sabes entonces ingresa 0`,
  target_number_or_level_reach: `Número objetivo o nivel a alcanzar`,
  target_we_aim_to_reach_is: `El objetivo que pretendemos alcanzar es`,
  from_starting_number_n_level: `desde el número/nivel inicial`,
  estimate_what_change_starting_para: `Opcional: ¿Estime cuál sería el cambio en el número/nivel inicial al final del cronograma de su Oportunidad si no interviniera?`,
  your_total_effort_will_be: `Tu esfuerzo total será`,
  taking_account_you_did_not_intervene: `teniendo en cuenta lo que pasaría si no intervinieras`,
  how_will_you_gather_evidence: `¿Cómo reunirá pruebas?`,
  please_enter_details: `Por favor ingresa los detalles`,
  evidence_verification_method: `Método de verificación de evidencia`,
  your_contribution: `Tu contribución`,
  measuring_your_impact: `Midiendo su impacto`,
  to_measure_the_progress_of_your_opportunity: `Para medir el progreso de su oportunidad, la empresa le ha solicitado agregar indicadores. Los indicadores le permiten establecer objetivos estimados, con hitos para alcanzarlos.`,
  opportunity_indicators: `Indicadores de oportunidad`,
  these_indicators_are_general_to_your_opportunity_or_entity: `Estos indicadores son generales para su oportunidad o entidad. Haga clic en 'Agregar' para crearlos.`,
  these_indicators_support_the_specific_objectives_and_outcomes: `Estos indicadores respaldan los objetivos y resultados específicos de su oportunidad. Por favor haga clic en 'Agregar' para crearlos.`,
  describe_the_starting_situation: `Describe la situación inicial:`,
  describe_the_final_situation: `Describa la situación final objetivo deseada:`,
  describe_the_final_title_situation: `Describa la situación final deseada:`,
  please_confirm_that_you_can_provide_any_of_following_evidence_items: `Confirme que puede proporcionar los siguientes elementos de evidencia`,
  starting_number_level_of_your_indicator: `Número inicial de su indicador`,
  target_number_or_level_to_reach: `Número objetivo a alcanzar`,
  estimate_what_the_change_in_the_starting_number: `Opcional: ¿Estime cuál sería el cambio en el número/nivel inicial al final del cronograma de su Oportunidad si no interviniera?`,
  the_target_we_aim_to_reach_is_employed_from_the_starting_number_level: `El objetivo que pretendemos alcanzar es el número de empleados empleados desde el número/nivel inicial.`,
  your_total_impact_will_be_employed: `Su impacto total será el impactoNúmero de empleados`,
  your_final_absolute_change_is_impactNumber: `Su cambio absoluto final es impactNumber`,
  your_final_relative_change_is_impactNumber: `Su cambio relativo final es impactNumber`,
  we_will_aim_for_sample_size_of_individuals: `Apuntaremos a un tamaño de muestra de 20 individuos...`,
  restrict_applications_to_within_certain_radius_of_this_location: `¿Restringir las aplicaciones a un radio determinado de esta ubicación?`,
  enter_number: `Introduzca el número`,
  biannually: `Semestralmente`,
  please_select_your_impact_strategy: `Por favor seleccione su estrategia de impacto`,
  reporting_requirements: `Requisitos de presentación de informes`,
  starting: `A partir de`,
  create_indicator: `Crear indicador`,
  optional_title: `Opcional`,
  optional_head: `¿Opcional?`,
  estimate_what_the_level_would_be: `¿Estime cuál sería el cambio en el número inicial para la fecha de finalización de su proyecto si no interviniera? (por favor agregue el signo +/-)`,
  this_value_cannot_be_more_than_the_amount_you_are_applying_for: `Este valor no puede ser mayor que el monto que estás solicitando.`,
  you_must_apply_for_100_percentage_of_the_total_project_cost: `Debes solicitar el 100% del costo total del proyecto.`,
  please_save_a_location: `Por favor guarda una ubicación`,
  i_agree: `Estoy de acuerdo`,
  project_running_dates: `Fechas de ejecución de los proyectos`,
  donations_required_before: `Donaciones requeridas antes`,
  add_programme: `Agregar programa`,
  budget_end_date: `Fecha de finalización del presupuesto`,
  application_window: `Ventana de aplicación`,
  choose_either_option: `Elija cualquiera de las opciones:`,
  copy_an_existing_programme: `Copiar un programa existente`,
  create_a_new_programme: `Crear un nuevo programa`,
  what_is_the_name_of_your_programme: `¿Cómo se llama su programa?`,
  what_is_the_area_of_impact: `¿Cuál es el área de impacto?`,
  projects_or_impact_must_be_within: `Los proyectos o impacto deben estar dentro de:`,
  a_custom_area: `Un área personalizada`,
  an_administrative_boundary_eg_a_council_area_or_country: `Un límite administrativo, p. un área del consejo o país.`,
  a_certain_distance_from_a_point: `A cierta distancia de un punto.`,
  click_on_the_map_to_start_drawing_your_area: `Haz clic en el mapa para empezar a dibujar tu zona, haz doble clic para completarlo. Si es necesario, puede eliminarlo desde la opción de nombre del área debajo del mapa haciendo clic en el icono de eliminación al lado derecho del`,
  use_the_search_box_to_find_administrative_boundaries: `Utilice el cuadro de búsqueda para encontrar límites administrativos. Vea un límite haciendo clic en el nombre, seleccione un límite haciendo clic en "Elegir". Elimine áreas o edite nombres de la sección de nombre de área debajo de `,
  click_on_the_map_to_add_a_point: `Haga clic en el mapa para agregar un punto, luego ingrese un radio permitido a continuación y presione 'Generar área' para mostrar el área en el mapa. Comience de nuevo haciendo clic en el mapa para agregar un nuevo punto.`,
  what_is_the_area_called: `¿Cómo se llama la zona?`,
  programme_details: `Detalles del programa`,
  write_a_short_summary_of_your_programme: `Escribe un breve resumen de tu programa.`,
  write_a_longer_description: `Escribe una descripción más larga`,
  do_you_wish_to_share_any_supporting_material: `¿Quieres compartir algún material de apoyo?`,
  select_all_options: `Seleccionar todas las opciones`,
  indicators: `Indicadores`,
  details: `Detalles`,
  programme_support: `Soporte del programa`,
  what_support_can_you_offer: `¿Qué apoyo puedes ofrecer?`,
  what_is_your_budget: `cual es tu presupuesto`,
  make_this_budget_amount_visible_in_your_programme_as_an_estimated_budget: `Haga que este monto del presupuesto sea visible en su programa como un "Presupuesto estimado".`,
  is_there_a_limit_donation_amount_per_project: `¿Existe un monto límite de donación por proyecto?`,
  projects_must_be_fully_funded_by_you_without_additional_third_party_funding: `Los proyectos deben ser financiados íntegramente por usted sin financiación adicional de terceros`,
  does_this_budget_recur: `¿Este presupuesto se repite?`,
  per_project: `Por proyecto`,
  no_it_is_fixed: `No, está arreglado.`,
  yes_annual_starting_on: `Sí, anual a partir de:`,
  please_include_in_your_invoice_the_following_details: `Por favor incluya en su factura los siguientes detalles...`,
  share_any_invoice_instructions_for_approved_grantees_to_view: `Comparta las instrucciones de la factura para que las vean los beneficiarios aprobados`,
  do_you_want_to_upload_an_invoice_template_for_approved_applicants_to_use: `¿Quiere cargar una plantilla de factura para que la utilicen los solicitantes aprobados?`,
  what_type_of_volunteering_can_you_offer: `¿Qué tipo de voluntariado podéis ofrecer?`,
  what_skilled_volunteering_is_available: `¿Qué voluntariado cualificado hay disponible?`,
  start_date: `Fecha de inicio`,
  end_date: `Fecha de finalización`,
  general: `General`,
  skilled: `Experto`,
  skill: `Habilidad`,
  number_of_item_service: `Número (de artículo/servicio)`,
  item_service_description: `Descripción del artículo/servicio`,
  what_type_of_in_kind_support_can_you_offer: `¿Qué tipo de apoyo en especie pueden ofrecer?`,
  timelines: `Líneas de tiempo`,
  when_are_you_accepting_applications: `¿Cuándo aceptan solicitudes?`,
  a_date_range: `Un rango de fechas`,
  ongoing: `En curso`,
  when_are_application_decisions_made: `¿Cuándo se toman las decisiones de solicitud?`,
  periodically: `Periódicamente`,
  when_do_you_expect_to_make_donations: `¿Cuándo esperas hacer Donaciones?`,
  do_you_want_to_restrict_project_timelines: `¿Quieres restringir los cronogramas del proyecto?`,
  projects_must_start_within: `Los proyectos deben comenzar dentro de`,
  projects_must_not_be_longer_than: `Los proyectos no deben tener una duración superior a`,
  months: `meses`,
  eligible_entities: `Entidades elegibles`,
  what_type_of_entity_is_able_to_apply_to_your_programme: `¿Qué tipo de entidad puede postularse a su programa?`,
  please_select_all_that_apply_below: `Seleccione todo lo que corresponda a continuación.`,
  uk: `Reino Unido`,
  international: `Internacional`,
  applicants_must_agree_to_these_before_applying: `Los solicitantes deben aceptar estos antes de presentar la solicitud.`,
  entity_project_must_be: `La entidad/proyecto debe ser...`,
  application_questions: `Preguntas de solicitud`,
  do_you_want_to_add_any_custom_application_questions: `¿Quieres agregar alguna pregunta sobre la aplicación personalizada?`,
  word_limit: `Límite de palabras`,
  question: `Pregunta`,
  please_enter_your_application_terms_and_conditions: `Por favor ingrese los términos y condiciones de su solicitud`,
  we_ask_all_applicants_to_approve_this_before_submitting_their_application: `Pedimos a todos los solicitantes que aprueben esto antes de enviar su solicitud.`,
  please_enter_a_link_to_your_privacy_policy: `Por favor ingrese un enlace a su política de privacidad`,
  we_ask_all_applicants_to_acknowledge_this_before_submitting_their_application: `Pedimos a todos los solicitantes que reconozcan esto antes de enviar su solicitud.`,
  measuring_impact: `Medición del impacto`,
  when_do_you_want_to_receive_interim_updates: `¿Cuándo desea recibir "Actualizaciones provisionales"?`,
  recurring_to_project_dates: `Recurrente a las fechas del proyecto.`,
  not_required: `No requerido`,
  every: `Cada`,
  days_between_project_start_and_end_dates: `Días entre las fechas de inicio y finalización del proyecto`,
  when_do_you_want_to_receive_a_final_report: `¿Cuándo desea recibir un "Informe final"?`,
  relative_to_project_dates: `En relación con las fechas del proyecto`,
  days_after_the_project_end_date: `Días después de la fecha de finalización del proyecto`,
  are_there_any_additional_questions_you_would_like_to_ask_in_the_final_report: `¿Hay alguna pregunta adicional que le gustaría hacer en el Informe Final?`,
  do_you_want_additional_legal_terms_for_entities_to_accept_on_submission_of_reports_to_you: `¿Quiere que las entidades acepten términos legales adicionales al enviarle informes?`,
  programme_administration: `Administración del programa`,
  internal_approval_steps: `Pasos de aprobación interna`,
  approval_step: `Paso de aprobación`,
  voting: `Votación`,
  scoring_category: `Categoría de puntuación`,
  create_the_categories_that_you_would_like_to_evaluate_applications_against: `Cree las categorías en las que le gustaría evaluar las aplicaciones, por ej. 'Valor por dinero' o 'Impacto total'`,
  insert: `Insertar`,
  scoring_category_options: `Opciones de categoría de puntuación`,
  detail_the_category_options_available_to_be_selected_for_the_above_categories: `Detalle las opciones de categoría disponibles para ser seleccionadas para las categorías anteriores con el "valor numérico" de cada opción, de modo que se pueda calcular una puntuación final. También puedes incluir opcionalmente una descripción.`,
  list_the_scoring_category_options_with_a_value_and_an_optional_description: `Enumere las opciones de categoría de puntuación con un valor y una descripción opcional. Por ejemplo, el valor podría ser "1" y la descripción "Baja" o el valor "3" y la descripción "Alta".`,
  numerical_value: `Valor numérico`,
  optional_description: `Descripción opcional`,
  who_will_manage_this_programme: `¿Quién gestionará este programa?`,
  managers_can_edit_the_programme_interact_with_applicants_approve_applications_and_receive_related_email_notifications: `Los gerentes pueden editar el programa, interactuar con los solicitantes, aprobar solicitudes y recibir notificaciones por correo electrónico relacionadas.`,
  who_can_view_this_programme: `¿Quién puede ver este programa?`,
  viewers_can_view_the_programme_and_applications_but_not_edit_the_programme: `Los espectadores pueden ver el programa y las solicitudes, pero no editar el programa, interactuar con los solicitantes, aprobar solicitudes ni recibir notificaciones por correo electrónico relacionadas.`,
  programme_visibility: `Visibilidad del programa`,
  bizGive_open: `BizGive (abierto)`,
  any_charity_signed_up_to_bizGive_can_view_and_apply_to_your_programme: `Cualquier organización benéfica registrada en BizGive puede ver y postularse a su programa.`,
  bizGive_invite_only: `BizGive (solo por invitación)`,
  only_charities_you_invite_to_apply_to_your_programme_can_view_it: `Solo las organizaciones benéficas que usted invite a postularse para su programa podrán verlo.`,
  public_open: `Público (Abierto)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive: `Su programa tendrá su propio enlace y página de inicio de marca en BizGive, para que pueda compartirlo en cualquier lugar fuera de la plataforma. Cualquier organización benéfica registrada en BizGive también podrá verlo y presentar su solicitud.`,
  public_invite_only: `Público (solo por invitación)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive_invite_them_to_apply: `Su programa tendrá su propio enlace y página de inicio de marca en BizGive, para que pueda compartirlo en cualquier lugar fuera de la plataforma. No será visible para las organizaciones benéficas registradas en BizGive, a menos que usted esté en`,
  add_a_custom_programme_url: `Agregar una URL de programa personalizada`,
  publish_your_programme: `Publica tu programa`,
  this_will_make_your_programme_visible_as_per_your_visibility_settings: `Esto hará que su programa sea visible según su configuración de visibilidad.`,
  you_can_still_edit_all_details_of_the_programmes_after_publishing: `Aún puedes editar todos los detalles de los programas después de su publicación.`,
  required_document_name: `Nombre del documento requerido`,
  change: `Cambiar`,
  number_of_days: `Número de días`,
  programme_approval: `Aprobación del programa`,
  there_must_be_at_least_1_votingScoreCriteria_added: `Debe haber al menos 1 criterio de puntuación de votación agregado`,
  there_must_be_at_least_1_votingCriteriaOptions_added: `Debe haber al menos 1 opción de criterio de votación agregada`,
  publish: `Publicar`,
  confirm: `Confirmar`,
  project_timeline: `Cronograma del proyecto`,
  company: `Compañía`,
  this_programme_is_closing_in_number_days: `Este programa se cierra en número de días.`,
  this_programme_is_now_closed: `Este programa ya está cerrado.`,
  the_application_window_is: `La ventana de la aplicación es`,
  login_or_signup_into_bizGive_to_discover_new_funding_programmes: `Inicie sesión o regístrese en BizGive para descubrir nuevos programas de financiación.`,
  discover_more_programmes: `Descubre más programas`,
  end: `Fin`,
  to_apply_to_the: `Para aplicar a la`,
  log_in_or_sign_up_to_create_your_free_bizGive_account: `Inicie sesión o regístrese para crear su cuenta BizGive gratuita.`,
  if_youre_new_to_BizGive_create_an_organisation_profile: `Si es nuevo en BizGive, cree un perfil de organización.`,
  complete_your_application_to_the_programme: `Complete su solicitud para el programa.`,
  receive_alerts_when_action_is_required_or_a_funding_decision_is_made: `Reciba alertas cuando sea necesario actuar o se tome una decisión de financiación.`,
  apply_to_other_programmes_from_the_discover_section: `Postula a otros programas desde la sección Descubrir.`,
  entity_location: `Ubicación de la entidad`,
  which_country_must_entities_be_located_in_leave_blank_if_any_are_accepted: `¿En qué país deben estar ubicadas las entidades? Dejar en blanco si se acepta alguno`,
  search_country: `Buscar país`,
  please_select_country: `Por favor seleccione el país`,
  your_requested_amount_exceeds_the_programme_limit: `El monto solicitado excede el límite del programa`,
  your_requested_amount_is_lower_than_the_programme_limit: `El monto solicitado es inferior al límite del programa`,
  your_requested_amount_does_not_equal_the_programme_limit: `El monto solicitado no equivale al límite del programa`,
  isLocal: `es local`,
  submission_date: `Fecha de presentación: `,
  local_within_km: `Local dentro de valor km`,
  group_by_visitor: `Grupo por visitante`,
  local_only: `Sólo locales`,
  within_km: `Dentro del valor km`,
  maximum_grant_size: `Tamaño máximo de subvención`,
  minimum_grant_size: `Tamaño mínimo de subvención`,
  none_required: `No se requiere ninguno`,
  outcome_title: `Resultado:`,
  consolidated_report: `Informe consolidado`,
  portfolio: `Cartera`,
  portfolio_name: `Nombre de la cartera`,
  period: `Período`,
  grant_size: `Tamaño de la subvención`,
  afghanistan: `Afganistán`,
  albania: `Albania`,
  algeria: `Argelia`,
  andorra: `Andorra`,
  angola: `Angola`,
  antigua_and_barbuda: `Antigua y Barbuda`,
  argentina: `Argentina`,
  armenia: `Armenia`,
  australia: `Australia`,
  austria: `Austria`,
  azerbaijan: `Azerbaiyán`,
  bahrain: `Bahrein`,
  bangladesh: `Bangladesh`,
  barbados: `Barbados`,
  belarus: `Bielorrusia`,
  belgium: `Bélgica`,
  belize: `Belice`,
  benin: `Benín`,
  bhutan: `Bután`,
  bolivia: `bolivia`,
  bosnia_and_herzegovina: `Bosnia y Herzegovina`,
  botswana: `Botsuana`,
  brazil: `Brasil`,
  brunei: `Brunéi`,
  bulgaria: `Bulgaria`,
  burkina_faso: `Burkina Faso`,
  burundi: `Burundi`,
  cambodia: `Camboya`,
  cameroon: `Camerún`,
  canada: `Canadá`,
  cape_verde: `Cabo Verde`,
  central_african_republic: `República Centroafricana`,
  chad: `Chad`,
  chile: `Chile`,
  china: `Porcelana`,
  colombia: `Colombia`,
  comoros: `Comoras`,
  congo: `Congo`,
  congo_democratic_republic: `Congo (República Democrática)`,
  costa_rica: `Costa Rica`,
  croatia: `Croacia`,
  cuba: `Cuba`,
  cyprus: `Chipre`,
  czechia: `Chequia`,
  denmark: `Dinamarca`,
  djibouti: `Yibuti`,
  dominica: `república dominicana`,
  dominican_republic: `República Dominicana`,
  east_timor: `Timor Oriental`,
  ecuador: `Ecuador`,
  egypt: `Egipto`,
  el_salvador: `Salvador`,
  equatorial_guinea: `Guinea Ecuatorial`,
  eritrea: `Eritrea`,
  estonia: `Estonia`,
  eswatini: `Esuatini`,
  ethiopia: `Etiopía`,
  fiji: `Fiyi`,
  finland: `Finlandia`,
  france: `Francia`,
  gabon: `Gabón`,
  georgia: `Georgia`,
  germany: `Alemania`,
  ghana: `Ghana`,
  greece: `Grecia`,
  grenada: `Granada`,
  guatemala: `Guatemala`,
  guinea: `Guinea`,
  guinea_bissau: `Guinea-Bisáu`,
  guyana: `Guayana`,
  haiti: `Haití`,
  honduras: `Honduras`,
  hungary: `Hungría`,
  iceland: `Islandia`,
  india: `India`,
  indonesia: `Indonesia`,
  iran: `Irán`,
  iraq: `Irak`,
  ireland: `Irlanda`,
  israel: `Israel`,
  italy: `Italia`,
  ivory_coast: `Costa de Marfil`,
  jamaica: `Jamaica`,
  japan: `Japón`,
  jordan: `Jordán`,
  kazakhstan: `Kazajstán`,
  kenya: `Kenia`,
  kiribati: `Kiribati`,
  kosovo: `Kosovo`,
  kuwait: `Kuwait`,
  kyrgyzstan: `Kirguistán`,
  laos: `Laos`,
  latvia: `Letonia`,
  lebanon: `Líbano`,
  lesotho: `Lesoto`,
  liberia: `Liberia`,
  libya: `Libia`,
  liechtenstein: `Liechtenstein`,
  lithuania: `Lituania`,
  luxembourg: `Luxemburgo`,
  madagascar: `Madagascar`,
  malawi: `Malaui`,
  malaysia: `Malasia`,
  maldives: `Maldivas`,
  mali: `Malí`,
  malta: `Malta`,
  marshall_islands: `Islas Marshall`,
  mauritania: `Mauritania`,
  mauritius: `Mauricio`,
  mexico: `México`,
  federated_states_of_micronesia: `Estados Federados de Micronesia`,
  moldova: `Moldavia`,
  monaco: `Mónaco`,
  mongolia: `Mongolia`,
  montenegro: `Montenegro`,
  morocco: `Marruecos`,
  mozambique: `Mozambique`,
  myanmar_burma: `Myanmar (Birmania)`,
  namibia: `Namibia`,
  nauru: `Nauru`,
  nepal: `Nepal`,
  netherlands: `Países Bajos`,
  new_zealand: `Nueva Zelanda`,
  nicaragua: `Nicaragua`,
  niger: `Níger`,
  nigeria: `Nigeria`,
  north_korea: `Corea del Norte`,
  north_macedonia: `Macedonia del Norte`,
  norway: `Noruega`,
  oman: `Omán`,
  pakistan: `Pakistán`,
  palau: `Palaos`,
  panama: `Panamá`,
  papua_new_guinea: `Papúa Nueva Guinea`,
  paraguay: `Paraguay`,
  peru: `Perú`,
  philippines: `Filipinas`,
  poland: `Polonia`,
  portugal: `Portugal`,
  qatar: `Katar`,
  romania: `Rumania`,
  russia: `Rusia`,
  rwanda: `Ruanda`,
  st_kitts_and_nevis: `San Cristóbal y Nieves`,
  st_lucia: `Santa Lucía`,
  st_vincent: `San Vicente`,
  samoa: `Samoa`,
  san_marino: `San Marino`,
  sao_tome_and_principe: `Santo Tomé y Príncipe`,
  saudi_arabia: `Arabia Saudita`,
  senegal: `Senegal`,
  serbia: `Serbia`,
  seychelles: `Seychelles`,
  sierra_leone: `Sierra Leona`,
  singapore: `Singapur`,
  slovakia: `Eslovaquia`,
  slovenia: `Eslovenia`,
  solomon_islands: `Islas Salomón`,
  somalia: `Somalia`,
  south_africa: `Sudáfrica`,
  south_korea: `Corea del Sur`,
  south_sudan: `Sudán del Sur`,
  spain: `España`,
  sri_lanka: `Sri Lanka`,
  sudan: `Sudán`,
  suriname: `Surinam`,
  sweden: `Suecia`,
  switzerland: `Suiza`,
  syria: `Siria`,
  tajikistan: `Tayikistán`,
  tanzania: `Tanzania`,
  thailand: `Tailandia`,
  the_bahamas: `las bahamas`,
  the_gambia: `Gambia`,
  togo: `Ir`,
  tonga: `Tonga`,
  trinidad_and_tobago: `Trinidad y Tobago`,
  tunisia: `Túnez`,
  turkey: `Pavo`,
  turkmenistan: `Turkmenistán`,
  tuvalu: `Tuvalu`,
  uganda: `Uganda`,
  ukraine: `Ucrania`,
  united_arab_emirates: `Emiratos Árabes Unidos`,
  united_kingdom: `Reino Unido`,
  united_states: `Estados Unidos`,
  uruguay: `Uruguay`,
  uzbekistan: `Uzbekistán`,
  vanuatu: `Vanuatu`,
  vatican_city: `Ciudad del Vaticano`,
  venezuela: `Venezuela`,
  vietnam: `Vietnam`,
  yemen: `Yemen`,
  zambia: `Zambia`,
  zimbabwe: `Zimbabue`,
  already_registered: `¿Ya estás registrado?`,
  login_here: `Inicia sesión aquí`,
  application_to: `Solicitud a`,
  continue_application: `Continuar solicitud`,
  delete_application: `Eliminar aplicación`,
  edit_resubmit: `Editar y volver a enviar`,
  withdraw: `Retirar`,
  this_will_withdraw_your_application_and_return_it_to_a_pending_state: `Esto retirará su solicitud y la devolverá al estado "Pendiente".`,
  this_will_delete_your_application_and_saved_data: `Esto eliminará su aplicación y los datos guardados.`,
  withdraw_application: `Retirar solicitud`,
  send: `Enviar`,
  enable_editing_of_application: `Habilitar edición de aplicación`,
  application_editing_enabled: `Edición de aplicaciones habilitada`,
  pre_approve: `Preaprobación`,
  withdraw_pre_approval: `Retirar la aprobación previa`,
  confirm_approval: `Confirmar aprobación`,
  grant_award: `Premio de subvención`,
  please_confirm_you_wish_to_approve_this_application: `Confirme que desea aprobar esta solicitud.`,
  share_a_message: `Comparte un mensaje:`,
  confirm_decline: `Confirmar rechazo`,
  please_explain_your_decision_to_the_applicant: `Por favor explique su decisión al solicitante.`,
  application_related: `Relacionado con la aplicación`,
  entity_related: `Relacionado con la entidad`,
  programme_related: `Relacionado con el programa`,
  add_a_message: `Agregar un mensaje`,
  there_are_items_we_cannot_fund: `Hay artículos que no podemos financiar`,
  the_impact_of_your_project_is_not_clear_enough: `El impacto de su proyecto no está lo suficientemente claro`,
  the_impact_of_your_project_is_lower_relative_to_other_applications: `El impacto de su proyecto es menor en relación con otras aplicaciones.`,
  your_entity_does_not_meet_our_criteria: `Su entidad no cumple con nuestros criterios`,
  your_project_does_not_align_closely_enough_with_our_objectives: `Su proyecto no se alinea lo suficiente con nuestros objetivos`,
  other_projects_more_closely_aligned_with_our_objectives: `Otros proyectos más alineados con nuestros objetivos`,
  your_project_did_not_fully_meet_our_eligibility_criteria: `Su proyecto no cumplió completamente con nuestros criterios de elegibilidad`,
  funding_in_this_round_has_already_been_disbursed_to_similar_projects: `La financiación de esta ronda ya se ha desembolsado para proyectos similares.`,
  please_select_an_decline_option_or_write_a_message: `Por favor seleccione una opción de rechazo o escriba un mensaje`,
  confirm_pre_approval: `Confirmar aprobación previa`,
  please_confirm_your_pre_approval: `Por favor confirme su aprobación previa.`,
  please_confirm_your_approval: `Por favor confirme su aprobación.`,
  pre_approving_will_not_notify_the_applicant: `La aprobación previa no notificará al solicitante.`,
  approving_will_not_notify_the_applicant: `La aprobación no notificará al solicitante.`,
  internal_review: `Revisión interna`,
  entity_history: `Historial de la entidad`,
  you_have_received_an_application_from_this_entity_before: `Ha recibido una solicitud de esta entidad anteriormente.`,
  approval: `Aprobación`,
  approved_by: `Aprobado por`,
  confirm_step_completion: `Confirmar finalización del paso`,
  please_confirm_this_step_has_been_completed: `Confirme que este paso se haya completado.`,
  total_score: `Puntuación total`,
  voters: `Votantes`,
  category_totals: `Totales de categoría`,
  name: `Nombre`,
  telephone: `Teléfono`,
  email: `Correo electrónico`,
  category_score: `Puntuación de categoría`,
  date: `Fecha`,
  my_vote: `mi voto`,
  saved: `Guardado`,
  vote: `Votar`,
  value_for_money: `Valor por dinero`,
  total_impact: `Impacto total`,
  total: `Total`,
  comments: `Comentarios`,
  edit: `Editar`,
  what_are_your_overall_comments: `¿Cuáles son sus comentarios generales?`,
  select_score: `Seleccionar puntuación`,
  please_select_at_least_one_checkbox: `Por favor seleccione al menos una casilla de verificación`,
  create_your_profile: `Crea tu perfil`,
  on_the_following_screens_you_will_be_asked_to_complete_a_profile_of_your_entity: `En las siguientes pantallas se le pedirá que complete un perfil de su entidad.`,
  how_your_profile_is_used: `Cómo se utiliza su perfil`,
  once_your_profile_is_complete_it_will_be_automatically_attached_to_any_application_you_submit_through_bizGive: `Una vez que su perfil esté completo, se adjuntará automáticamente a cualquier solicitud que envíe a través de BizGive.`,
  companies_and_bizGive_use_your_profile_to_perform_background_due_diligence_checks_on_your_organisation_it_is_only_visible_to_companies_you_apply_to: `Las empresas y BizGive utilizan su perfil para realizar verificaciones de diligencia debida de antecedentes en su organización. Solo es visible para las empresas a las que postula.`,
  once_complete_you_will_be_able_to_apply_to_as_many_company_programmes_as_you_re_eligible_for_from_the_discover_tab: `Una vez completado, podrá postularse a tantos programas de la empresa para los que sea elegible desde la pestaña "Descubrir".`,
  profile_guidance: `Guía de perfil`,
  saves_your_data_and_moves_you_to_the_next_screen_your_answers_will_automatically_be_saved_unless_you_have_an_internet_connectivity_issue: `guarda sus datos y lo lleva a la siguiente pantalla. Tus respuestas se guardarán automáticamente, a menos que tengas un problema de conectividad a Internet.`,
  saves_your_data_and_logs_you_out_of_bizGive: `guarda sus datos y cierra su sesión en BizGive. Podrá continuar con su perfil cuando vuelva a iniciar sesión. Deberá completar todos los campos obligatorios para "Guardar y salir" (puede ingresar valores aleatorios).`,
  entity_details: `Detalles de la entidad`,
  name_n_address: `Nombre y dirección`,
  do_you_have_a_different_trading_name_or_display_name: `¿Tiene un nombre comercial o un nombre para mostrar diferente?`,
  legal_structure: `Estructura Jurídica`,
  what_is_your_legal_structure: `¿Cuál es su estructura jurídica?`,
  unregistered_organisation: `Organización no registrada`,
  what_is_your_registration_number: `¿Cuál es su número de registro?`,
  this_is_your_registration_number_with_the_relevant_regulator_of_your_entity: `Este es su número de registro ante el regulador correspondiente de su entidad.`,
  please_share_a_link_to_your_online_registration: `Por favor comparta un enlace a su registro en línea`,
  this_is_a_link_to_your_profile_on_the_regulators_website: `Este es un enlace a su perfil en el sitio web del regulador.`,
  please_upload_a_copy_of_your_governing_document: `Cargue una copia de sus documentos rectores.`,
  these_are_not_available: `Estos no están disponibles`,
  please_share_a_reason: `Por favor comparte una razón`,
  please_upload_a_copy_of_your_governing_documents: `Cargue una copia de sus documentos rectores.`,
  for_example_your_trust_deed: `Por ejemplo, su escritura de fideicomiso.`,
  please_upload_a_copy_of_your_most_recent_annual_accounts: `Cargue una copia de sus cuentas anuales más recientes.`,
  for_example_your_Articles_of_association: `Por ejemplo, sus estatutos.`,
  please_upload_a_copy_of_your_constitution_trust_deed_or_rules: `Cargue una copia de su constitución, escritura de fideicomiso o reglas.`,
  please_upload_a_copy_of_your_registration_documents_or_most_recent_annual_accounts: `Cargue una copia de sus documentos de registro o de las cuentas anuales más recientes.`,
  entity_types: `Tipos de entidad`,
  registered_with_the_relevant_national_or_regional_regulatory_authority_for_example_the_charity_commission_in_the_uk: `Registrado ante la autoridad reguladora nacional o regional pertinente. Por ejemplo, la Comisión de Caridad del Reino Unido.`,
  community_interest_company_uk_only: `Compañía de interés comunitario (solo en el Reino Unido)`,
  registered_with_companies_house: `Registrado en la Cámara de Empresas. Una forma especial de sociedad limitada sin fines de lucro que existe para beneficiar a una comunidad o perseguir un propósito social. Muchas empresas sociales son CIC.`,
  a_type_of_charity_run_by_a_small_group_of_people_known_as_trustees: `Un tipo de organización benéfica dirigida por un pequeño grupo de personas conocidas como fideicomisarios. En el Reino Unido, un fideicomiso debe registrarse ante la Comisión de Caridad cuando sus ingresos anuales superan las 5.000 libras esterlinas.`,
  an_educational_institution_such_as_a_university_or_school: `Una institución educativa como una Universidad o Escuela.`,
  an_entity_that_is_not_registered_or_regulated_for_example_clubs_societies_and_small_community_groups: `Una entidad que no está registrada ni regulada. Por ejemplo, clubes, sociedades y pequeños grupos comunitarios.`,
  a_type_of_charitable_organisation_registered_as_a_company_limited_by_guarantee: `Un tipo de organización caritativa registrada como Sociedad Limitada por Garantía u otra estructura corporativa sin fines de lucro. En el Reino Unido, están registradas en Companies House como Company Limited por Gu.`,
  organisations_that_are_responsible_for_the_provision_of_public_services: `Organismos que se encargan de la prestación de servicios públicos.`,
  trustees: `Fideicomisarios`,
  please_provide_the_name_of_your_trustees_or_directors: `Proporcione el nombre de sus fideicomisarios o directores.`,
  a_minimum_of_two_is_required_only_1_is_required_if_you_are_a_uk_cic: `Se requiere un mínimo de 2. Solo se requiere 1 si es un CIC del Reino Unido.`,
  where_are_you_able_to_run_your_projects: `¿Dónde puedes ejecutar tus proyectos?`,
  based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you: `Según sus selecciones, podremos recomendarle nuevos programas de financiación relevantes.`,
  countries_of_operation: `Países de operación`,
  within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only: `Dentro de los países seleccionados, ¿pueden ejecutar proyectos a nivel nacional o solo en ubicaciones específicas?`,
  nationwide: `A escala nacional`,
  specific_locations: `Ubicaciones específicas`,
  please_describe_what_your_organisation_does: `Por favor describa lo que hace su organización.`,
  please_provide_a_brief_overview_of_your_groups_purpose_aims_and_objectives: `Proporcione una breve descripción del propósito, las metas y los objetivos de su grupo.`,
  social_media: `Redes Sociales`,
  please_share_a_link_to_your_website: `Por favor comparta un enlace a su sitio web.`,
  if_applicable_please_share_your_social_media_links: `Si corresponde, comparta sus enlaces de redes sociales.`,
  please_add_your_entity_logo: `Por favor agregue el logo de su entidad`,
  please_upload: `Por favor sube`,
  your_profile_is_complete: `Tu perfil está completo`,
  you_can: `Puede`,
  edit_title_caption: `'Editar'`,
  your_profile_at_any_point_by_clicking_into: `su perfil en cualquier momento haciendo clic en 'Mi organización' > 'Perfil' > 'Editar'`,
  what_happens_next: `¿Qué pasa después?`,
  start_your_application: `Inicie su solicitud`,
  if_you_accessed_bizGive_via_a_company_programme: `Si accedió a BizGive a través de un programa empresarial, haga clic en "Aplicar" para iniciar su formulario de solicitud.`,
  discover_company_programmes: `Descubra los programas de la empresa`,
  click_discover_to_view_and_apply_to_live_company_support_programmes: `Haga clic en "Descubrir" para ver y postularse a programas de soporte empresarial en vivo.`,
  enter_url: `Ingrese la URL`,
  please_upload_documentation: `Por favor cargue la documentación`,
  council_or_government_linked_entity: `Consejo o entidad vinculada al gobierno`,
  locations: `Ubicaciones`,
  specific_locations_within_each_country: `Ubicaciones específicas dentro de cada país`,
  entity_type: `Tipo de entidad`,
  legal_name: `Nombre Legal`,
  governing_documents: `Documentos rectores`,
  operating_location: `Ubicación de operación`,
  nationally_in_the_following_countries: `A nivel nacional en los siguientes países:`,
  locally_in_the_following_countries: `Localmente en los siguientes países:`,
  not_available: `No disponible`,
  registration_number: `Número de registro`,
  trading_name: `Nombre comercial`,
  web_uri: `URI web`,
  registration_profile_url: `URL del perfil de registro`,
  discover_funding_opportunities: `Descubra oportunidades de financiación`,
  available_programmes_filtered_by_your_entitys_area_of_operation: `Programas disponibles Filtrados por área de operación de su entidad:`,
  change_here: `Cambiar aquí`,
  programme: `Programa`,
  applications_accepted: `Solicitudes aceptadas`,
  decision_made: `Decisión tomada`,
  location: `Ubicación`,
  action: `Acción`,
  your_entity_type_is_not_supported_by_this_programme: `Este programa no admite su tipo de entidad.`,
  please_click_ok_and_view_the_permitted_entities_in_the_programme_review_page: `Haga clic en "Aceptar" y vea las entidades permitidas en la página de revisión del programa.`,
  content: `Contenido`,
  select_programme: `Seleccionar programa`,
  select_report_type: `Seleccione el tipo de informe`,
  enter_start_date: `Ingrese la fecha de inicio`,
  enter_end_date: `Introduzca la fecha de finalización`,
  report: `Informe`,
  overdue: `Atrasado`,
  view_report: `Ver informe`,
  start_report: `Iniciar informe`,
  complete_report: `Informe completo`,
  add_your_profile_picture: `Añade tu foto de perfil`,
  project: `Proyecto`,
  registration_website: `Sitio web de registro`,
  outside_of_impact_area: `Fuera del área de impacto`,
  this_interim_update_is_for: `Esta actualización provisional es para`,
  interim_update_deadline: `Fecha límite de actualización provisional`,
  form_guidance: `Orientación sobre el formulario`,
  in_the_form_you_will_be_asked_to_share_details_of_the_project_you_received_funding_for: `En el formulario, se le pedirá que comparta detalles del proyecto para el que recibió financiación.`,
  to_access_a_saved_interim_update_click_into_impact: `Para acceder a una actualización provisional guardada: haga clic en Impacto > Contenido > Informe completo`,
  to_access_a_saved_interim_update_click_into_impact_content: `Para ver una actualización provisional enviada: haga clic en Impacto > Contenido > Ver informe`,
  interim_update: `Actualización provisional`,
  below_is_the_support_you_requested_from_the_company_in_your_application: `A continuación se muestra el soporte que solicitó a la empresa en su solicitud.`,
  how_have_you_used_the_support_provided_so_far: `¿Cómo ha utilizado el apoyo brindado hasta ahora?`,
  are_there_any_changes_to_your_planned_expenditure_and_if_so_why: `¿Hay algún cambio en sus gastos planificados y, de ser así, por qué?`,
  are_there_any_changes_to_your_estimated_completion_date_and_if_so_why: `¿Hay algún cambio en la fecha estimada de finalización y, de ser así, por qué?`,
  please_email_bizGive: `Envíe un correo electrónico a BizGive`,
  if_there_is_a_substantial_change_to_your_completion_date_and_we_will_ensure_the_deadline_for_your_final_report_is_update: `si hay un cambio sustancial en su fecha de finalización y nos aseguraremos de que se actualice la fecha límite para su Informe final.`,
  share_images: `Compartir imágenes`,
  please_upload_images_to_bring_your_project_to_life_this_significantly_increases_the_likelihood_of_the_company_sharing_your_content: `Sube imágenes para darle vida a tu proyecto. Esto aumenta significativamente la probabilidad de que la empresa comparta su contenido.`,
  sends_your_form_to_the_company: `envía su informe a la empresa. Este botón aparece en la pantalla final del formulario.`,
  submit_your_report: `Envíe su informe`,
  i_have_read_and_agree_to_the_above_terms: `He leído y acepto los términos anteriores.`,
  add_files: `Agregar archivos`,
  please_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Confirme que se hayan agregado todos los derechos de autor y reconocimientos necesarios.`,
  i_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Confirmo que se han agregado todos los derechos de autor y reconocimientos necesarios.`,
  final_report_deadline: `Fecha límite del informe final`,
  please_press_add_to_save_the_invited_user: `Por favor presione agregar para guardar el usuario invitado`,
  inputs: `Entradas`,
  did_any_of_your_plans_change: `¿Cambió alguno de tus planes?`,
  please_select_and_enter_your_final_inputs: `Por favor seleccione e ingrese sus entradas finales`,
  please_update_your_expenditure: `Por favor actualice sus gastos`,
  please_update_the_items_or_services_you_used: `Actualice los artículos o servicios que utilizó.`,
  please_update_the_volunteering_support_you_used: `Actualice el apoyo de voluntariado que utilizó.`,
  below_are_the_outputs_you_shared_in_your_application: `A continuación se muestran los resultados que compartió en su solicitud.`,
  did_your_outputs_change: `¿Cambiaron sus resultados?`,
  please_update_your_outputs: `Por favor actualice sus resultados`,
  your_outputs_will_show_like_this_in_your_report: `Sus resultados se mostrarán así en su informe:`,
  i_acknowledge_the: `reconozco el`,
  below_are_the_beneficiaries_you_shared_in_your_application: `A continuación se muestran los beneficiarios que compartió en su solicitud.`,
  did_your_social_beneficiary_types_change: `¿Cambiaron sus tipos de beneficiarios sociales?`,
  please_update_your_social_beneficiary_types: `Actualice sus tipos de beneficiarios sociales`,
  did_your_social_beneficiary_numbers_change: `¿Cambió su número de beneficiarios sociales?`,
  please_update_your_social_beneficiary_numbers: `Por favor actualice sus números de beneficiario social`,
  did_your_environmental_beneficiaries_change: `¿Cambiaron sus beneficiarios ambientales?`,
  please_update_your_environmental_beneficiaries: `Por favor actualice sus beneficiarios ambientales`,
  below_are_the_objectives_and_outcomes_you_shared_in_your_application: `A continuación se detallan los objetivos y resultados que compartió en su solicitud.`,
  objectives_n_outcomes: `Objetivos y resultados`,
  were_you_successful_in_achieving_your_objectives_and_outcomes: `¿Tuvo éxito en lograr sus objetivos y resultados?`,
  inputs_n_outputs: `Entradas y salidas`,
  case_studies: `Estudios de caso`,
  preview_n_submit: `Vista previa y envío`,
  impact_measures: `Medidas de impacto`,
  the_company_has_requested_you_to_add_indicators_to_measure_the_progress_of_your_project: `La empresa le ha solicitado que agregue indicadores para medir el progreso de su proyecto.`,
  general_indicators: `Indicadores generales`,
  these_indicators_are_general_to_your_opportunity_or_entity_please_click_add_to_create_them: `Estos indicadores son generales para su oportunidad o entidad. Haga clic en "Agregar" para crearlos.`,
  indicator: `Indicador`,
  required: `¿Requerido?`,
  target: `Objetivo`,
  final_title: `Final`,
  status: `Estado`,
  project_indicators: `Indicadores del proyecto`,
  the_indicators_below_are_linked_to_your_selected_objectives_and_outcomes_please_click_add_to_create_them: `Los indicadores a continuación están vinculados a los objetivos y resultados seleccionados. Haga clic en "Agregar" para crearlos.`,
  objective: `Objetivo`,
  outcome: `Resultado`,
  achieved: `Logrado`,
  your_absolute_impact_is: `Tu impacto absoluto es impactNumber`,
  your_relative_impact_is: `Su impacto relativo es impactNumber`,
  case_studies_and_media: `Estudios de caso y medios`,
  case_studies_and_images_increase_the_likelihood_of_the_company_sharing_your_project_where_possible_please_share_a_case_study_and_at_least_one_image: `Los estudios de casos y las imágenes aumentan la probabilidad de que la empresa comparta su proyecto. Cuando sea posible, comparta un estudio de caso y al menos una imagen.`,
  add_case_study: `Agregar estudio de caso`,
  add_images: `Agregar imágenes`,
  please_upload_this_file_type_in_the_add_files_section_below: `Cargue este tipo de archivo en la sección Agregar archivos a continuación`,
  please_upload_images_in_the_additional_images_section_above: `Cargue imágenes en la sección "Imágenes adicionales" arriba`,
  upload_any_image_files_here_png_jpg: `Cargue aquí cualquier archivo de imagen, p. .png, .jpg`,
  upload_any_documents_that_you_wish_to_share: `Cargue cualquier documento que desee compartir, p. .doc, .pdf o .xlsx`,
  case_study_name: `Nombre del estudio de caso`,
  what_impact_did_your_project_have: `¿Qué impacto tuvo su proyecto?`,
  add_a_description: `Agregar una descripción`,
  for_example_what_was_there_at_start_what_did_you_do_and_what_was_the_result: `Por ejemplo: ¿qué había al principio, qué hiciste y cuál fue el resultado?`,
  share_a_quote_such_as_from_a_beneficiary: `Compartir una cotización, como la de un beneficiario.`,
  quote_by: `Cita por`,
  please_share_any_images: `Por favor comparte cualquier imagen.`,
  what_happens_next_for_example_are_you_planning_to_develop_your_project_further: `¿Qué pasa a continuación? Por ejemplo, ¿planea seguir desarrollando su proyecto?`,
  if_you_would_like_to_share_anything_else_with_the_company_please_use_the_box_below: `Si desea compartir algo más con la empresa, utilice el cuadro a continuación`,
  the_company_has_requested_some_additional_information: `La empresa ha solicitado información adicional.`,
  content_agreement: `Acuerdo de contenido`,
  view_agreement: `Ver acuerdo`,
  application_agreement: `Acuerdo de solicitud`,
  send_message: `Enviar mensaje`,
  this_final_Report_is_for: `Este Informe Final es para`,
  company_questions: `Preguntas de la empresa`,
  next_steps: `Próximos pasos`,
  additional_details: `Detalles adicionales`,
  objectives_and_outcomes: `Objetivos y resultados`,
  planned: `Planificado`,
  actual: `Actual`,
  days: `Días`,
  of_equivalent_value: `de valor equivalente`,
  case_study: `Estudio de caso`,
  includes_changes: `Incluye cambios`,
  hundred_as_planned: `100% según lo planeado`,
  show_planned_efforts: `Mostrar esfuerzos planificados`,
  final: `Final`,
  support_awarded: `Apoyo otorgado`,
  password_reset_expired: `Restablecimiento de contraseña caducado`,
  please_select_forgot_password_again_and_click_on_the_email_to_reset_your_password_within_fifteen_minutes: `Seleccione 'Olvidé mi contraseña' nuevamente y haga clic en el correo electrónico para restablecer su contraseña dentro de 15 minutos.`,
  please_check_check_your_spam_folder_if_the_email_is_not_immediately_visible: `Verifique su carpeta de correo no deseado si el correo electrónico no es visible de inmediato.`,
  request: `Pedido`,
  please_note_this_email_address_needs_to_match_the_address: `Tenga en cuenta: esta dirección de correo electrónico debe coincidir con la dirección a la que recibió su invitación.`,
  an_access_email_has_sent_to: `Se ha enviado un correo electrónico de acceso a:`,
  you_can_close_this_tab: `Puedes cerrar esta pestaña.`,
  we_couldnt_find_your_email_address: `No pudimos encontrar su dirección de correo electrónico. Asegúrese de que sea el mismo que su correo electrónico de invitación.`,
  the_feedback_portal_link_has_now_expired: `El enlace del Portal de comentarios ya ha caducado.`,
  please_contact_your_programme_administrator_if_you_still_require_access: `Comuníquese con el administrador de su programa si aún necesita acceso.`,
  verify: `Verificar`,
  the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email: `La dirección de correo electrónico ingresada no coincide con su enlace único. Asegúrese de que sea el mismo que su correo electrónico de invitación.`,
  email_entered: `Correo electrónico ingresado`,
  try_again: `Intentar otra vez`,
  welcome_to_your_voting_panel: `¡Bienvenido a tu panel de votación!`,
  please_click_review_to_assess_each_application_and_then_cast_your_vote: `Haga clic en "Revisar" para evaluar cada solicitud y luego emita su voto.`,
  please_enter_your_name: `Por favor ingresa tu nombre`,
  registered_charity: `Caridad registrada`,
  charitable_company: `Empresa benéfica`,
  community_interest_company: `Empresa de interés comunitario`,
  charitable_trust: `Fideicomiso caritativo`,
  for_profit_company: `Empresa con fines de lucro`,
  academic_institution: `Institución Académica`,
  government_linked_entity: `Entidad vinculada al gobierno`,
  parish_or_community_council: `Consejo Parroquial o Comunitario`,
  please_upload_a_copy_of_your_governing_document1: `Por favor cargue una copia de su documento de gobierno.`,
  please_upload_a_copy_of_your_governing_document2: `Por favor cargue una copia de su documento de gobierno.`,
  please_upload_a_copy_of_your_governing_document4: `Por favor cargue una copia de su documento de gobierno.`,
  insert_number: `Insertar número`,
  bring_the_project_to_life_share_pictures_of_what_you_will_be_changing_or_plan_to_achieve: `Dale vida al proyecto. Comparta imágenes de lo que cambiará o planea lograr.`,
  please_select_an_existing_user_or_invite_a_new_one: `Seleccione un usuario existente o invite a uno nuevo.`,
  decisions_to_be_made: `Decisiones a tomar:`,
  please_add_at_least_one_criteria: `Por favor agregue al menos un criterio`,
  see_full_report: `Ver informe completo`,
  internal_actions: `Acciones Internas`,
  country_af: `Afganistán`,
  country_ax: `Islas Aland`,
  country_al: `Albania`,
  country_dz: `Argelia`,
  country_as: `Samoa Americana`,
  country_ad: `Andorra`,
  country_ao: `Angola`,
  country_ai: `Anguila`,
  country_aq: `Antártida`,
  country_ag: `Antigua y Barbuda`,
  country_ar: `Argentina`,
  country_am: `Armenia`,
  country_aw: `Aruba`,
  country_au: `Australia`,
  country_at: `Austria`,
  country_az: `Azerbaiyán`,
  country_bs: `bahamas`,
  country_bh: `Bahrein`,
  country_bd: `Bangladesh`,
  country_bb: `Barbados`,
  country_by: `Bielorrusia`,
  country_be: `Bélgica`,
  country_bz: `Belice`,
  country_bj: `Benín`,
  country_bm: `islas Bermudas`,
  country_bt: `Bután`,
  country_bo: `Bolivia, Estado Plurinacional de`,
  country_bq: `Bonaire, San Eustaquio y Saba`,
  country_ba: `Bosnia y Herzegovina`,
  country_bw: `Botsuana`,
  country_bv: `Isla Bouvet`,
  country_br: `Brasil`,
  country_io: `Territorio Británico del Océano Índico`,
  country_bn: `Brunéi Darussalam`,
  country_bg: `Bulgaria`,
  country_bf: `Burkina Faso`,
  country_bi: `Burundi`,
  country_cv: `Cabo Verde`,
  country_kh: `Camboya`,
  country_cm: `Camerún`,
  country_ca: `Canadá`,
  country_ky: `Islas Caimán`,
  country_cf: `República Centroafricana`,
  country_td: `Chad`,
  country_cl: `Chile`,
  country_cn: `Porcelana`,
  country_cx: `Isla de Navidad`,
  country_cc: `Islas Cocos (Keeling)`,
  country_co: `Colombia`,
  country_km: `Comoras`,
  country_cg: `Congo`,
  country_cd: `Congo, República Democrática del`,
  country_ck: `Islas Cook`,
  country_cr: `Costa Rica`,
  country_ci: `Costa de Marfil`,
  country_hr: `Croacia`,
  country_cu: `Cuba`,
  country_cw: `Curazao`,
  country_cy: `Chipre`,
  country_cz: `Chequia`,
  country_dk: `Dinamarca`,
  country_dj: `Yibuti`,
  country_dm: `república dominicana`,
  country_do: `República Dominicana`,
  country_ec: `Ecuador`,
  country_eg: `Egipto`,
  country_sv: `Salvador`,
  country_gq: `Guinea Ecuatorial`,
  country_er: `Eritrea`,
  country_ee: `Estonia`,
  country_sz: `Esuatini`,
  country_et: `Etiopía`,
  country_fk: `Islas Malvinas (Falkland)`,
  country_fo: `Islas Feroe`,
  country_fj: `Fiyi`,
  country_fi: `Finlandia`,
  country_fr: `Francia`,
  country_gf: `Guayana Francesa`,
  country_pf: `Polinesia Francesa`,
  country_tf: `Territorios Australes Franceses`,
  country_ga: `Gabón`,
  country_gm: `Gambia`,
  country_ge: `Georgia`,
  country_de: `Alemania`,
  country_gh: `Ghana`,
  country_gi: `Gibraltar`,
  country_gr: `Grecia`,
  country_gl: `Tierra Verde`,
  country_gd: `Granada`,
  country_gp: `Guadalupe`,
  country_gu: `Guam`,
  country_gt: `Guatemala`,
  country_gg: `Guernesey`,
  country_gn: `Guinea`,
  country_gw: `Guinea-Bisáu`,
  country_gy: `Guayana`,
  country_ht: `Haití`,
  country_hm: `Islas Heard y McDonald`,
  country_va: `Santa Sede`,
  country_hn: `Honduras`,
  country_hk: `Hong Kong`,
  country_hu: `Hungría`,
  country_is: `Islandia`,
  country_in: `India`,
  country_id: `Indonesia`,
  country_ir: `Irán, República Islámica de`,
  country_iq: `Irak`,
  country_ie: `Irlanda`,
  country_im: `isla de man`,
  country_il: `Israel`,
  country_it: `Italia`,
  country_jm: `Jamaica`,
  country_jp: `Japón`,
  country_je: `Jersey`,
  country_jo: `Jordán`,
  country_kz: `Kazajstán`,
  country_ke: `Kenia`,
  country_ki: `Kiribati`,
  country_kp: `Corea, República Popular Democrática de`,
  country_kr: `Corea, República de`,
  country_kw: `Kuwait`,
  country_kg: `Kirguistán`,
  country_la: `República Democrática Popular Lao`,
  country_lv: `Letonia`,
  country_lb: `Líbano`,
  country_ls: `Lesoto`,
  country_lr: `Liberia`,
  country_ly: `Libia`,
  country_li: `Liechtenstein`,
  country_lt: `Lituania`,
  country_lu: `Luxemburgo`,
  country_mo: `macao`,
  country_mg: `Madagascar`,
  country_mw: `Malaui`,
  country_my: `Malasia`,
  country_mv: `Maldivas`,
  country_ml: `Malí`,
  country_mt: `Malta`,
  country_mh: `Islas Marshall`,
  country_mq: `Martinica`,
  country_mr: `Mauritania`,
  country_mu: `Mauricio`,
  country_yt: `Mayotte`,
  country_mx: `México`,
  country_fm: `Micronesia, Estados Federados de`,
  country_md: `Moldavia, República de`,
  country_mc: `Mónaco`,
  country_mn: `Mongolia`,
  country_me: `Montenegro`,
  country_ms: `Montserrat`,
  country_ma: `Marruecos`,
  country_mz: `Mozambique`,
  country_mm: `Birmania`,
  country_na: `Namibia`,
  country_nr: `Nauru`,
  country_np: `Nepal`,
  country_nl: `Países Bajos, Reino de la`,
  country_nc: `Nueva Caledonia`,
  country_nz: `Nueva Zelanda`,
  country_ni: `Nicaragua`,
  country_ne: `Níger`,
  country_ng: `Nigeria`,
  country_nu: `Niue`,
  country_nf: `Isla Norfolk`,
  country_mk: `Macedonia del Norte`,
  country_mp: `Islas Marianas del Norte`,
  country_no: `Noruega`,
  country_om: `Omán`,
  country_pk: `Pakistán`,
  country_pw: `Palaos`,
  country_ps: `Palestina, Estado de`,
  country_pa: `Panamá`,
  country_pg: `Papúa Nueva Guinea`,
  country_py: `Paraguay`,
  country_pe: `Perú`,
  country_ph: `Filipinas`,
  country_pn: `Pitcairn`,
  country_pl: `Polonia`,
  country_pt: `Portugal`,
  country_pr: `Puerto Rico`,
  country_qa: `Katar`,
  country_re: `Reunión`,
  country_ro: `Rumania`,
  country_ru: `Federación Rusa`,
  country_rw: `Ruanda`,
  country_bl: `San Bartolomé`,
  country_sh: `Santa Elena, Ascensión y Tristán da Cunha`,
  country_kn: `San Cristóbal y Nieves`,
  country_lc: `Santa Lucía`,
  country_mf: `San Martín (parte francesa)`,
  country_pm: `San Pedro y Miquelón`,
  country_vc: `San Vicente y las Granadinas`,
  country_ws: `Samoa`,
  country_sm: `San Marino`,
  country_st: `Santo Tomé y Príncipe`,
  country_sa: `Arabia Saudita`,
  country_sn: `Senegal`,
  country_rs: `Serbia`,
  country_sc: `Seychelles`,
  country_sl: `Sierra Leona`,
  country_sg: `Singapur`,
  country_sx: `Sint Maarten (parte holandesa)`,
  country_sk: `Eslovaquia`,
  country_si: `Eslovenia`,
  country_sb: `Islas Salomón`,
  country_so: `Somalia`,
  country_za: `Sudáfrica`,
  country_gs: `Islas Georgias del Sur y Sandwich del Sur`,
  country_ss: `Sudán del Sur`,
  country_es: `España`,
  country_lk: `Sri Lanka`,
  country_sd: `Sudán`,
  country_sr: `Surinam`,
  country_sj: `Svalbard y Jan Mayen`,
  country_se: `Suecia`,
  country_ch: `Suiza`,
  country_sy: `República Árabe Siria`,
  country_tw: `Taiwán, Provincia de China`,
  country_tj: `Tayikistán`,
  country_tz: `Tanzania, República Unida de`,
  country_th: `Tailandia`,
  country_tl: `Timor Oriental`,
  country_tg: `Ir`,
  country_tk: `Tokelau`,
  country_to: `Tonga`,
  country_tt: `Trinidad y Tobago`,
  country_tn: `Túnez`,
  country_tr: `Turquía`,
  country_tm: `Turkmenistán`,
  country_tc: `Islas Turcas y Caicos`,
  country_tv: `Tuvalu`,
  country_ug: `Uganda`,
  country_ua: `Ucrania`,
  country_ae: `Emiratos Árabes Unidos`,
  country_gb: `Reino Unido de Gran Bretaña e Irlanda del Norte`,
  country_us: `Estados Unidos de América`,
  country_um: `Islas menores alejadas de los Estados Unidos`,
  country_uy: `Uruguay`,
  country_uz: `Uzbekistán`,
  country_vu: `Vanuatu`,
  country_ve: `Venezuela, República Bolivariana de`,
  country_vn: `Vietnam`,
  country_vg: `Islas Vírgenes (Británicas)`,
  country_vi: `Islas Vírgenes (EE.UU.)`,
  country_wf: `Wallis y Futuna`,
  country_eh: `Sáhara Occidental`,
  country_ye: `Yemen`,
  country_zm: `Zambia`,
  country_zw: `Zimbabue`
  }

export default esLocale;
